"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTableApp = void 0;
exports.dashUserToRawEmployment = dashUserToRawEmployment;
exports.sortUsers = sortUsers;
exports.fetchAllUsers = fetchAllUsers;
exports.fetchAllDashSlots = fetchAllDashSlots;
exports.calcSlotMap = calcSlotMap;
exports.dashSlotToShift = dashSlotToShift;
exports.dashSlotToRawShift = dashSlotToRawShift;
exports.normalizeSectionToParentDate = normalizeSectionToParentDate;
exports.filterUsersToWorkerOnly = filterUsersToWorkerOnly;
exports.roleIdMatchesSummaryFilter = roleIdMatchesSummaryFilter;
exports.filterUsersToThoseWithRoleSlot = filterUsersToThoseWithRoleSlot;
exports.filterUsersByTags = filterUsersByTags;
exports.filterUsers = filterUsers;
exports.filterFetchedSlotsForView = filterFetchedSlotsForView;
exports.calculateDurationBeforeLastShift = calculateDurationBeforeLastShift;
exports.prepareFetchedSlotsForView = prepareFetchedSlotsForView;
exports.calcUserIdsToFetch = calcUserIdsToFetch;
exports.calcTagsProp = calcTagsProp;
exports.calcAppUserMap = calcAppUserMap;
exports.parseSummaryQueryParams = parseSummaryQueryParams;
exports.decodeTags = decodeTags;
exports.calcDedupedTagsListFromUsers = calcDedupedTagsListFromUsers;
exports.computeEditModeCellProps = computeEditModeCellProps;
exports.computeRoleCountData = computeRoleCountData;
exports.calcSlotsToDelete = calcSlotsToDelete;
exports.calcStatsIdBatches = calcStatsIdBatches;
exports.isSlotInRange = isSlotInRange;
exports.calcStatsBatchFromShiftStore = calcStatsBatchFromShiftStore;
exports.calcSlotIDsForBulkDelete = calcSlotIDsForBulkDelete;
exports.calcMaxUpdatedAt = calcMaxUpdatedAt;
exports.calcCloneLaborHours = calcCloneLaborHours;
exports.calcExcludedDateStrings = calcExcludedDateStrings;
const vue_1 = require("vue");
const SummaryTable_vue_1 = __importDefault(require("../view/components/summaryTable/SummaryTable.vue"));
const employmentShiftTable_1 = require("../employmentShiftTable/employmentShiftTable");
const provider_1 = require("../provider/provider");
const summaryTable_1 = require("../presenter/summaryTable");
const summary_1 = require("../requests/summary");
const common_1 = require("../common/common");
const models_1 = require("../js/models");
const luxon_1 = require("luxon");
const shift_1 = require("../view/shift/shift");
const shift_2 = require("../model/v1/shift");
const summary_lib_1 = require("../js/summary_lib");
const shiftStore_1 = require("../store/v1/shiftStore");
const summary_common_1 = require("../js/summary_common");
const autoai_poll_1 = require("../view/components/autoAI/autoai_poll");
const employmentShiftTableStats_1 = require("../employmentShiftTable/employmentShiftTableStats");
const common_2 = require("../js/common");
const table_1 = require("../table/v1/table");
const periodTypes_1 = __importDefault(require("../table/v1/periodTypes"));
const IndexedDBStorage_1 = require("../storage/IndexedDBStorage");
const storageSummary_1 = require("../storage/storageSummary");
const stats_1 = require("../stats/stats");
const shiftCellStats_1 = require("../stats/shiftCellStats");
const shiftRowStats_1 = require("../stats/shiftRowStats");
const shiftColumnStats_1 = require("../stats/shiftColumnStats");
const provider_2 = require("../spotworker/provider");
const spotShiftStore_1 = require("../spotworker/stores/spotShiftStore");
const spotWorkerStore_1 = require("../spotworker/stores/spotWorkerStore");
const useSpotWorkerStats_1 = require("../spotworker/summaryPage/composable/useSpotWorkerStats");
var DashSlotIndexNames;
(function (DashSlotIndexNames) {
    DashSlotIndexNames["SlotBranchIdFromIndex"] = "slotBranchIdFromIndex";
    DashSlotIndexNames["SlotUserIdGroupIdFromIndex"] = "slotUserIdGroupIdFromIndex";
    DashSlotIndexNames["SlotCachedAtIndex"] = "slotCachedAtIndex";
})(DashSlotIndexNames || (DashSlotIndexNames = {}));
var DashUserIndexNames;
(function (DashUserIndexNames) {
    DashUserIndexNames["UserCachedAtIndex"] = "userCachedAtIndex";
})(DashUserIndexNames || (DashUserIndexNames = {}));
var SlotToQueryIndexNames;
(function (SlotToQueryIndexNames) {
    SlotToQueryIndexNames["SlotIdIndex"] = "slotIdIndex";
})(SlotToQueryIndexNames || (SlotToQueryIndexNames = {}));
// Max entity count in single db. Begin deleting oldest after hitting max.
const MAX_CACHE_SIZE = 30000;
// Max slots per stats worker batch.
const MAX_SLOTS_STATS_BATCH = 500;
// Slot bulk delete
const BULK_DELETE_POLL_INTERVAL_MS = 5000;
const BULK_DELETE_POLL_RETRY_LIMIT = 3;
const SlotBulkDeleteState = {
    None: "0",
    Inprogress: "1",
    Done: "2"
};
class SummaryTableApp {
    viewApp;
    presenter;
    // Provided by summary_lib. Static values.
    tableDates = [];
    branch;
    settings;
    templates = [];
    roleStore;
    meStore;
    canEdit = false;
    viewType;
    hasAutoPerm = false;
    showMemo = false;
    branchDefaultMaxMonthly;
    branchDefaultMonthlyVacationLimit = 0;
    roleCountData;
    canViewSpotWork;
    // Managed by app. Require updates on slot and user changes.
    slotMap = (0, vue_1.shallowReactive)({});
    cellsMap = (0, vue_1.ref)({});
    nightMergedCellsMap = (0, vue_1.ref)({});
    editModeCellProps = (0, vue_1.ref)({});
    summaryStats;
    employmentStore;
    shiftStore;
    query;
    useSectionWage;
    // List of filtered user ids. Used to help optimize presenters.
    userIdsInView = [];
    // Subject-like. Consider read only by any presentation function.
    slots = new Map();
    users = [];
    intervalSourceSlots = [];
    // Stats worker
    statsWorker;
    // Flag to give up on cached computation jobs.
    cancelCachedComputeJob = false;
    // Flag to indicate stats computation was completed with cached data.
    cachedStatsCompleted = false;
    // Hold current task batches in memory.
    taskBatches; // [["slotid1", "slotid2"], ["slotid3"]]
    // Cache
    summaryDb;
    slotCacheWorker;
    userCacheWorker;
    // Worker imports don't currently work with FE development server.
    useWorkers = process.env.NODE_ENV !== "development";
    // Cache read-only view
    isReadOnly = (0, vue_1.ref)(true);
    durationBeforeLastShiftBySlotId = (0, vue_1.ref)({});
    // Bulk delete state request retry
    cntSlotBulkDelStateReqRetry = 0;
    timerBulkDelRequest = null;
    // Spotworker
    spotShiftStore;
    spotWorkerStore;
    spotWorkerSummaryLoaded = false;
    spotWorkerSummaryLoad;
    constructor(useSectionWage, canViewSpotWork) {
        this.canViewSpotWork = canViewSpotWork || false;
        this.viewApp = (0, vue_1.createApp)(SummaryTable_vue_1.default);
        this.presenter = new summaryTable_1.SummaryTablePresenterImpl();
        this.initPresentation();
        this.query = parseSummaryQueryParams(document.location.search);
        this.viewApp.provide(provider_1.summaryTableCellsMapInjectKey, (0, vue_1.readonly)(this.cellsMap));
        this.viewApp.provide(provider_1.summaryTableNightMergedCellsMapInjectKey, (0, vue_1.readonly)(this.nightMergedCellsMap));
        this.viewApp.provide(provider_1.summaryTableSlotMapInjectKey, this.slotMap);
        this.viewApp.provide(provider_1.summaryTableBulkDeleteInjectKey, async (action) => { await this.bulkDeleteSlots(action); });
        this.viewApp.provide(provider_1.summaryTablePresenterInjectKey, this.presenter);
        this.viewApp.provide(provider_1.summaryTableDurationBeforeLastShiftBySlotIdInjectKey, (0, vue_1.readonly)(this.durationBeforeLastShiftBySlotId));
        // Adding readonly(), which stops view from mutating view model, causes ts to report error: is 'readonly' and cannot be assigned to the mutable type 'SummaryTableEmployeeRow[]'.
        // It's a known typescript quirk (https://stackoverflow.com/questions/62225769/inconsistency-with-typescript-readonly-type) but doesn't appear in other repos. I am assuming it's a config issue.
        // Ignoring the typescript check for now as ignoring it makes the view model readonly and there doesn't seem to be any resulting type issues.
        // @ts-ignore
        this.viewApp.provide(provider_1.summaryTableEditModePropsInjectKey, (0, vue_1.readonly)(this.editModeCellProps));
        this.useSectionWage = useSectionWage || false;
    }
    // init will:
    // 1. Init and present a read-only table with cached data
    // 2. Init and present an editable table with fresh data
    async init() {
        await this.initCache();
        await this.getFromCacheAndPresent();
        if (this.canViewSpotWork) {
            this.initAndProvideSpotStores();
        }
        // For now because of DOM selectors for stats and other features,
        // Must init presentation and then mount otherwise DOM selection can't find elements.
        this.mount();
        if (this.useWorkers) {
            this.initStatsWorker();
        }
        this.calcStatsCached();
        await this.fetchAndPresent();
        if (this.canViewSpotWork) {
            try {
                // Load spot-worker data before rendering the summary totals. The rows
                // remain collapsed, but the totals must include spot-worker shifts.
                await this.loadSpotWorkerSummary();
            }
            catch (err) {
                alert(err);
                console.error(err);
            }
        }
    }
    // calcStatsCached will compute stats for all cached slot data in shift store and render.
    calcStatsCached() {
        const firstDate = this.tableDates[0]?.getDate();
        const endTableDate = this.tableDates[this.tableDates.length - 1]?.getEnd();
        if (!this.settings || !this.shiftStore || !firstDate || !endTableDate) {
            return;
        }
        // Background batched cannot currently support split night shift or linked slots. Use previous sync compute.
        const useSplitNightCompute = this.settings.splitNightShift || this.viewHasLinkedSlots();
        if (useSplitNightCompute) {
            this.calcSplitNightStatsSync();
            this.onCalcStatsFinish();
            return;
        }
        if (!this.statsWorker) {
            // Use sync compute.
            this.calcStatsSync();
            return;
        }
        this.taskBatches = calcStatsIdBatches(this.shiftStore, MAX_SLOTS_STATS_BATCH, firstDate, endTableDate, this.settings.splitNightShift);
        const firstBatch = this.taskBatches.pop();
        if (!firstBatch) {
            this.onBgStatsFinish(false);
            return;
        }
        this.statsBgBatched(firstBatch, true);
    }
    // calcStats will compute stats for all slot data in shift store, render, and call secondary functions that rely on stats computation completion.
    calcStats() {
        const firstDate = this.tableDates[0]?.getDate();
        const endTableDate = this.tableDates[this.tableDates.length - 1]?.getEnd();
        if (!this.settings || !this.shiftStore || !firstDate || !endTableDate) {
            return;
        }
        // Background batched cannot currently support split night shift or linked slots. Use previous sync compute.
        const useSplitNightCompute = this.settings.splitNightShift || this.viewHasLinkedSlots();
        if (useSplitNightCompute) {
            this.calcSplitNightStatsSync();
            this.onCalcStatsFinish();
            // Stats computation with fresh data completed. Allow slot editing.
            this.allowWrites();
            this.renderUserLaborBadges();
            return;
        }
        if (!this.statsWorker) {
            // Use sync compute.
            this.calcStatsSync();
            // Stats computation with fresh data completed. Allow slot editing.
            this.allowWrites();
            this.renderUserLaborBadges();
            return;
        }
        this.taskBatches = calcStatsIdBatches(this.shiftStore, MAX_SLOTS_STATS_BATCH, firstDate, endTableDate, this.settings.splitNightShift);
        const firstBatch = this.taskBatches.pop();
        if (!firstBatch) {
            this.onBgStatsFinish(true);
            return;
        }
        this.statsBgBatched(firstBatch, false);
    }
    viewHasLinkedSlots() {
        if (!this.shiftStore) {
            return false;
        }
        for (const slotId in this.shiftStore.data) {
            const s = this.shiftStore.byId(slotId);
            if (s?.isLinkedShift()) {
                return true;
            }
        }
        return false;
    }
    initStatsWorker() {
        // @ts-ignore
        this.statsWorker = new Worker(new URL(/* webpackChunkName: "summaryStats.worker" */ "../worker/summaryStats.ts", import.meta.url), { type: 'module' });
        this.statsWorker.addEventListener('message', (message) => {
            // Our stats computation has taken longer than it took to get new slot data. Give up on current computation job.
            if (message.data.isUsingCachedData && this.cancelCachedComputeJob) {
                return;
            }
            this.applySlotStatsListToStats(message.data.stats);
            const nextBatch = this.taskBatches?.pop();
            if (!nextBatch) {
                // Task is complete.
                this.onBgStatsFinish(!message.data.isUsingCachedData);
                return;
            }
            this.statsBgBatched(nextBatch, message.data.isUsingCachedData);
        });
    }
    // DEPRECATED. A temporary solution to allow edit mode to access employment store.
    getEmploymentStore() {
        return this.employmentStore;
    }
    getPresenter() {
        return this.presenter;
    }
    setCanEdit(canEdit) {
        this.canEdit = canEdit;
    }
    setBranchDefaultMaxMonthly(max) {
        this.branchDefaultMaxMonthly = max;
    }
    setBranchDefaultMonthlyVacationLimit(val) {
        this.branchDefaultMonthlyVacationLimit = val;
    }
    setShowMemo(show) {
        this.showMemo = show;
    }
    setRoleCountData(data) {
        this.roleCountData = data;
    }
    setHasAutoPerm(has) {
        this.hasAutoPerm = has;
    }
    setViewType(t) {
        this.viewType = t;
    }
    setTemplates(ts) {
        this.templates = ts;
    }
    setTableDates(td) {
        this.tableDates = td;
        this.presenter.initDates(td);
    }
    setScheduleIntervals(td, settings) {
        const firstDate = td[0];
        const lastDate = td[td.length - 1];
        if (!firstDate || !lastDate) {
            return;
        }
        this.presenter.initScheduleIntervals((0, common_1.toOplusTime)(firstDate.getDate()), (0, common_1.toOplusTime)(lastDate.getDate()), settings);
    }
    setBranch(b) {
        this.branch = b;
        this.viewApp.provide('activeBranch', this.branch);
    }
    async initCache() {
        if (this.useWorkers) {
            // @ts-ignore
            // import.meta.url use works but current config throws an error.
            this.slotCacheWorker = new Worker(new URL(/* webpackChunkName: "summarySlotCache.worker" */ "../worker/summarySlotCache.ts", import.meta.url), { type: 'module' });
            this.slotCacheWorker.addEventListener('message', (e) => {
                this.cacheSlotsBatchedBackground(e.data.queryKey, e.data.updatedAtGt, e.data.cursor);
            });
            // @ts-ignore
            // import.meta.url use works but current config throws an error.
            this.userCacheWorker = new Worker(new URL(/* webpackChunkName: "summaryUserCache.worker" */ "../worker/summaryUserCache.ts", import.meta.url), { type: 'module' });
        }
        else {
            console.info("Use synchronous cache puts.");
        }
        try {
            const sumDb = new IndexedDBStorage_1.IndexedDBStorage(storageSummary_1.summaryDb);
            await sumDb.init(storageSummary_1.dashUserStore);
            await sumDb.createIndex(storageSummary_1.dashUserStore, {
                name: DashUserIndexNames.UserCachedAtIndex,
                keyPath: "cachedAtMs",
            });
            await sumDb.init(storageSummary_1.dashSlotStore);
            // Composite index slots by branch id and from ms
            // Allows for a date range query by branch
            await sumDb.createIndex(storageSummary_1.dashSlotStore, {
                name: DashSlotIndexNames.SlotBranchIdFromIndex,
                keyPath: ["branchId", "fromMs"]
            });
            // Composite index slots by user id, group id, and from ms
            // Allows for a date range query by user id and group id. Required for clones.
            await sumDb.createIndex(storageSummary_1.dashSlotStore, {
                name: DashSlotIndexNames.SlotUserIdGroupIdFromIndex,
                keyPath: ["userId", "groupId", "fromMs"],
            });
            await sumDb.createIndex(storageSummary_1.dashSlotStore, {
                name: DashSlotIndexNames.SlotCachedAtIndex,
                keyPath: "cachedAtMs",
            });
            await sumDb.init(storageSummary_1.cachedQueriesStore);
            await sumDb.init(storageSummary_1.slotToCachedQueryStore);
            await sumDb.createIndex(storageSummary_1.slotToCachedQueryStore, {
                name: SlotToQueryIndexNames.SlotIdIndex,
                keyPath: "slotId",
            });
            this.summaryDb = sumDb;
        }
        catch (e) {
            console.error(`Failed to init cache: ${e}`);
        }
    }
    async deleteSlotsFromCacheAndInvalidate(slotIds) {
        if (!this.summaryDb || !slotIds.length) {
            return;
        }
        const toDelete = [];
        try {
            const queriesToDelete = new Set();
            for (const slotId of slotIds) {
                toDelete.push({
                    key: slotId,
                    storeName: storageSummary_1.dashSlotStore,
                });
                const entries = await this.summaryDb.getAllFromIndexForKey(storageSummary_1.slotToCachedQueryStore, SlotToQueryIndexNames.SlotIdIndex, slotId);
                for (const entry of entries) {
                    if (!queriesToDelete.has(entry.queryKey)) {
                        toDelete.push({
                            key: entry.queryKey,
                            storeName: storageSummary_1.cachedQueriesStore,
                        });
                        queriesToDelete.add(entry.queryKey);
                    }
                    toDelete.push({
                        key: (0, storageSummary_1.calcCachedSlotToQueryKey)(entry.slotId, entry.queryKey),
                        storeName: storageSummary_1.slotToCachedQueryStore,
                    });
                }
            }
            await this.summaryDb.deleteBatchKeysMultiStore(toDelete);
        }
        catch (e) {
            console.error(e);
        }
    }
    async deleteSlotsFromCache(slotIds) {
        if (!this.summaryDb || !slotIds.length) {
            return;
        }
        try {
            const toDelete = [];
            for (const slotId of slotIds) {
                toDelete.push({
                    key: slotId,
                    storeName: storageSummary_1.dashSlotStore,
                });
                const entries = await this.summaryDb.getAllFromIndexForKey(storageSummary_1.slotToCachedQueryStore, SlotToQueryIndexNames.SlotIdIndex, slotId);
                for (const entry of entries) {
                    toDelete.push({
                        key: (0, storageSummary_1.calcCachedSlotToQueryKey)(entry.slotId, entry.queryKey),
                        storeName: storageSummary_1.slotToCachedQueryStore,
                    });
                }
            }
            await this.summaryDb.deleteBatchKeysMultiStore(toDelete);
        }
        catch (e) {
            console.error(e);
        }
    }
    async enforceSlotCacheLimit() {
        if (!this.summaryDb) {
            return;
        }
        try {
            const size = await this.summaryDb.getTotalEntityCount(storageSummary_1.dashSlotStore);
            if (size <= MAX_CACHE_SIZE) {
                return;
            }
            const toDelete = await this.summaryDb.getKeysPageFromIndexAsc(storageSummary_1.dashSlotStore, DashSlotIndexNames.SlotCachedAtIndex, size - MAX_CACHE_SIZE);
            // Index does not contain all entities. Avoid infinite loop.
            if (toDelete.length === 0) {
                return;
            }
            await this.deleteSlotsFromCacheAndInvalidate(toDelete);
            const sizeAfter = await this.summaryDb.getTotalEntityCount(storageSummary_1.dashSlotStore);
            if (sizeAfter <= MAX_CACHE_SIZE) {
                return;
            }
            this.enforceSlotCacheLimit();
        }
        catch (e) {
            console.error(`Failed to enforce slot cache limit: ${e}`);
        }
    }
    async enforceUserCacheLimit() {
        if (!this.summaryDb) {
            return;
        }
        try {
            const size = await this.summaryDb.getTotalEntityCount(storageSummary_1.dashUserStore);
            if (size <= MAX_CACHE_SIZE) {
                return;
            }
            const numberDeleted = await this.summaryDb.deleteFromIndexAscUntilSize(storageSummary_1.dashUserStore, DashUserIndexNames.UserCachedAtIndex, size - MAX_CACHE_SIZE);
            // Index does not contain all entities. Avoid infinite loop.
            if (numberDeleted === 0) {
                return;
            }
            const sizeAfter = await this.summaryDb.getTotalEntityCount(storageSummary_1.dashUserStore);
            if (sizeAfter <= MAX_CACHE_SIZE) {
                return;
            }
            this.enforceUserCacheLimit();
        }
        catch (e) {
            console.error(`Failed to enforce user cache limit: ${e}`);
        }
    }
    async getAllSlotsFromCache(branchId, groupId, employeeIds, fromGte, fromLt, lockedOnly, roleIds) {
        if (!this.summaryDb) {
            return [];
        }
        const oplusTimeFromGte = (0, common_1.toOplusTime)(fromGte);
        const oplusTimeFromLt = (0, common_1.toOplusTime)(fromLt);
        const roleIdSet = roleIds === "all" ? "all" : new Set(roleIds);
        const hasRoleFilter = roleIds === "all" || Boolean(roleIds?.length);
        const branchRoleIdSet = getBranchRoleIdSet(this.roleStore);
        const matchesRoleFilter = (slot) => {
            return roleIdMatchesSummaryFilter(slot.roleId, roleIdSet, branchRoleIdSet);
        };
        const lower = [branchId, oplusTimeFromGte.valueOf()];
        const upper = [branchId, oplusTimeFromLt.valueOf()];
        const slots = await this.summaryDb.getAllFromIndexInRange(storageSummary_1.dashSlotStore, DashSlotIndexNames.SlotBranchIdFromIndex, lower, upper, false, true);
        // If no role filter, fetch clones for employees even if they don't have a slot at current branch.
        const fetchClones = hasRoleFilter ? null : employeeIds;
        // Using branch slots from date range, build list of working users
        const userIdSet = new Set(fetchClones);
        for (const s of slots) {
            if ((lockedOnly && !s.isLocked) || (hasRoleFilter && !matchesRoleFilter(s))) {
                continue;
            }
            userIdSet.add(s.userId);
        }
        const out = [];
        // Get all slots by user id for date range, including clones
        for await (const userId of userIdSet) {
            const lower = [userId, groupId, oplusTimeFromGte.valueOf()];
            const upper = [userId, groupId, oplusTimeFromLt.valueOf()];
            const userSlots = await this.summaryDb.getAllFromIndexInRange(storageSummary_1.dashSlotStore, DashSlotIndexNames.SlotUserIdGroupIdFromIndex, lower, upper, false, true);
            for (const s of userSlots) {
                if ((lockedOnly && !s.isLocked) || (hasRoleFilter && !matchesRoleFilter(s))) {
                    continue;
                }
                out.push(s);
            }
        }
        return out;
    }
    async getUsersForBranchAndUserIdsFromCache(branchId, userIds) {
        if (!this.summaryDb) {
            return [];
        }
        const out = [];
        for await (const userId of userIds) {
            const u = await this.summaryDb.get(storageSummary_1.dashUserStore, (0, storageSummary_1.dashUserCacheId)(branchId, userId));
            if (!u) {
                continue;
            }
            out.push(u);
        }
        return out;
    }
    async getFromCacheAndPresent() {
        if (!this.branch || !this.settings) {
            return;
        }
        let slots = [];
        try {
            const firstDate = this.tableDates[0];
            const endTableDate = this.tableDates[this.tableDates.length - 1];
            if (!firstDate || !endTableDate) {
                throw new Error();
            }
            // fetch one extra day to handle edge case for counting if interval from the previous shift exceeds threshold
            const actualFirstDate = firstDate.getDate();
            actualFirstDate.setDate(actualFirstDate.getDate() - 1);
            const fromLt = new Date(endTableDate.getEnd().valueOf() + 1);
            const fetchedSlots = await this.getAllSlotsFromCache(this.branch.id, this.branch.groupId, this.branch.employeeIds, actualFirstDate, fromLt, this.query.isLocked, this.query.roleIds);
            const prepared = prepareFetchedSlotsForView(fetchedSlots, firstDate.getDate(), this.settings.splitNightShift, this.settings.getTimeZone());
            slots = prepared.slots;
            this.intervalSourceSlots = fetchedSlots;
            this.durationBeforeLastShiftBySlotId.value = prepared.durationBeforeLastShiftBySlotId;
        }
        catch (e) {
            console.error(`Failed to get slots from cache: ${e}`);
            return;
        }
        // Notify subject
        this.addSlotsToSlotMap(slots);
        let users = [];
        try {
            users = await this.getUsersForBranchAndUserIdsFromCache(this.branch.id, calcUserIdsToFetch(this.branch.employeeIds, slots));
        }
        catch (e) {
            console.error(`Failed to get users from cache: ${e}`);
            return;
        }
        this.users = users;
        const allUserTags = calcDedupedTagsListFromUsers(users);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        const filters = {
            roleIds: this.query.roleIds,
            userTags: userTagsFilters,
            isLocked: this.query.isLocked,
            workerOnly: this.query.workerOnly,
        };
        this.presentSlotsAndUsersReadOnly(users, slots, filters);
    }
    async fetchAndPresent() {
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore || !firstDate || !endTableDate) {
            return;
        }
        const endDate = endTableDate.getEnd();
        // TODO: This is creating incorrect query keys. Fix and force cache bust.
        const queryKey = (0, storageSummary_1.calcSlotQueryDbKey)(this.branch.id, firstDate.getDate(), endDate, this.query.roleIds, this.query.isLocked);
        let slots = [];
        let ids = [];
        // fetch one extra day to handle edge case for counting if interval from the previous shift exceeds threshold & for split night shift
        const weekdayFirst = firstDate.getDate().getDay();
        let diff = (weekdayFirst - this.settings.getWeekStart() + 7) % 7;
        if (diff === 0) {
            diff = 1;
        }
        const daysInAdvance = new Date(firstDate.getDate());
        daysInAdvance.setDate(daysInAdvance.getDate() - diff);
        try {
            const { slots: allSlots } = await fetchAllDashSlots(this.branch.id, daysInAdvance, endDate, this.query.roleIds, this.query.isLocked);
            const prepared = prepareFetchedSlotsForView(allSlots, daysInAdvance, this.settings.splitNightShift, this.settings.getTimeZone());
            slots = prepared.slots;
            ids = prepared.ids;
            this.intervalSourceSlots = allSlots;
            this.durationBeforeLastShiftBySlotId.value = prepared.durationBeforeLastShiftBySlotId;
        }
        catch (e) {
            alert("シフトの読み込みができませんでした。");
            console.error(e);
            return;
        }
        // Subject provides previous values on update
        const previousSlots = new Map();
        for (const s of slots) {
            const prev = this.slots.get(s.id);
            if (prev) {
                previousSlots.set(prev.id, prev);
            }
        }
        const slotIdsToDelete = calcSlotsToDelete(ids, this.slots);
        // Notify subject
        this.addSlotsToSlotMap(slots);
        // Subject provides previous values on delete
        const slotsToDelete = [];
        for (const id of slotIdsToDelete) {
            const s = this.slots.get(id);
            if (!s) {
                continue;
            }
            slotsToDelete.push(s);
            this.slots.delete(id);
        }
        const allSlots = [];
        for (const [, s] of this.slots) {
            allSlots.push(s);
        }
        const { slots: filteredSlots } = filterFetchedSlotsForView(allSlots, firstDate.getDate().valueOf(), this.settings.splitNightShift, this.settings.getTimeZone());
        // Controller
        let allUsers = [];
        try {
            const userIds = calcUserIdsToFetch(this.branch.employeeIds, filteredSlots);
            // this counts the most frequent year/month combo to calculate the current monthly view's month
            // this is needed instead of using firstDate because firstDate sometimes can be from the previous month, this gives us a guarantee that the most frequent will be picked
            // shouldn't be too bad for performance since it's only looping about ~30 times
            const counts = new Map();
            for (const date of this.tableDates) {
                const key = `${date.getDate().getFullYear()}-${date.getDate().getMonth()}`; // e.g. "2025-2"
                counts.set(key, (counts.get(key) || 0) + 1);
            }
            let mostFrequentKey = null;
            let maxCount = 0;
            for (const [key, count] of counts) {
                if (count > maxCount) {
                    maxCount = count;
                    mostFrequentKey = key;
                }
            }
            if (mostFrequentKey) {
                const [year, month] = mostFrequentKey.split("-").map(Number);
                if (year !== undefined && month !== undefined) {
                    allUsers = await fetchAllUsers(this.branch.id, userIds, year, month);
                }
            }
        }
        catch (e) {
            alert("スタッフの読み込みができませんでした。");
            console.error(e);
            return;
        }
        // Subject provides previous values on update
        const prevUserTransportCostMap = new Map();
        for (const u of this.users) {
            prevUserTransportCostMap.set(u.userId, u.transport);
        }
        // Notify subject
        this.users = allUsers;
        const allUserTags = calcDedupedTagsListFromUsers(allUsers);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        const filters = {
            roleIds: this.query.roleIds,
            userTags: userTagsFilters,
            isLocked: this.query.isLocked,
            workerOnly: this.query.workerOnly,
        };
        // In the case that the background stats computation using cached data was still running, clear the task.
        this.cancelCachedComputeJob = true;
        // Present
        const filteredUsers = filterUsers(allUsers, filteredSlots, filters.workerOnly ?? false, filters.userTags, filters.roleIds, getBranchRoleIdSet(this.roleStore));
        const filteredUserIds = filteredUsers.map(du => du.userId);
        const filteredUserSet = new Set(filteredUserIds);
        // User set change currently requires stats re-init.
        const userSetHasNotChanged = this.userIdsInView.length === filteredUserSet.size && !this.userIdsInView.some(id => !filteredUserSet.has(id));
        // Repeat changes require re-init.
        const noRepeatSlotChanges = !filteredSlots.some(s => s.isRepeat) && !slotsToDelete.some(s => s.isRepeat);
        // Can avoid lots of re-calcs if no user set change.
        if (userSetHasNotChanged && noRepeatSlotChanges) {
            const sortedUsers = sortUsers(filteredUsers, this.branch.employeeIds);
            const sortedUserIds = sortedUsers.map(du => du.userId);
            this.initPresentationEmployeeRows(sortedUsers);
            // If the diff is big, then use async stats to avoid blocking main thread.
            const smallSlotDiff = filteredSlots.length + slotsToDelete.length < 100;
            // A transport cost change currently requires a full stats re-init.
            let transportHasNotChanged = true;
            for (const user of filteredUsers) {
                const prevTransport = prevUserTransportCostMap.get(user.userId);
                if (prevTransport !== user.transport) {
                    transportHasNotChanged = false;
                    break;
                }
            }
            const useSyncStats = smallSlotDiff && transportHasNotChanged && this.cachedStatsCompleted;
            this.presentSlotDeletes(slotsToDelete, daysInAdvance, endDate, useSyncStats);
            this.presentSlotUpdates(filteredSlots, previousSlots, filteredUserSet, daysInAdvance, endDate, useSyncStats);
            if (useSyncStats) {
                this.onBgStatsFinish(true);
            }
            else {
                const rawEmployments = [];
                for (const u of filteredUsers) {
                    rawEmployments.push(dashUserToRawEmployment(u));
                }
                this.initStats(rawEmployments, filteredSlots);
                this.calcStats();
            }
            // Must do.
            // Required for slot modal to fill in user values
            (0, summary_lib_1.setGlobalAppUserMap)(calcAppUserMap(sortedUsers));
            this.editModeCellProps.value = computeEditModeCellProps(this.tableDates, sortedUserIds, this.settings.getTimeZone());
            const rawSlots = [];
            for (const s of filteredSlots) {
                if (!filteredUserSet.has(s.userId)) {
                    continue;
                }
                rawSlots.push(dashSlotToRawShift(s, this.settings, firstDate.getDate(), endTableDate.getEnd(), this.settings.getTimeZone()));
            }
            (0, summary_lib_1.toggleUnlockSlotBtn)(rawSlots);
        }
        else {
            if (slotsToDelete.length) {
                // Deleting slots not returned from server currently requires manually updating role counts.
                // Can be removed when stats are made into a ref.
                for (const s of slotsToDelete) {
                    this.updateStatsOnRawSlotDelete(dashSlotToRawShift(s, this.settings, firstDate.getDate(), endTableDate.getEnd(), this.settings.getTimeZone()));
                }
                this.renderStats();
            }
            // Pass unfiltered slots.
            this.presentSlotsAndUsers(filteredUsers, allSlots, filters);
            this.calcStats();
        }
        await this.deleteSlotsFromCache(slotIdsToDelete);
        // Do not await.
        this.cacheView(queryKey, calcMaxUpdatedAt(slots));
        this.enforceUserCacheLimit();
    }
    addSlotsToSlotMap(slots) {
        const repeatsMap = new Map();
        for (const s of slots) {
            if (s.isRepeat) {
                // Only store the earliest repeat instance of the current fetch.
                const curFrom = repeatsMap.get(s.id);
                if (curFrom && curFrom < new Date(s.from)) {
                    continue;
                }
                repeatsMap.set(s.id, new Date(s.from));
            }
            this.slots.set(s.id, s);
        }
    }
    async cacheView(queryKey, updatedAtGtToSave) {
        if (this.userCacheWorker) {
            const messageData = {
                users: this.users,
            };
            this.userCacheWorker.postMessage(messageData);
        }
        else {
            try {
                // Use main thread put.
                await (0, storageSummary_1.cacheUsers)(this.users);
            }
            catch (e) {
                console.error(`Failed to cache view: ${e}`);
            }
        }
        await this.cacheAllSlots(queryKey, updatedAtGtToSave);
    }
    cacheSlotsBatchedBackground(queryKey, updatedAtGtToSave, cursor) {
        if (!this.slotCacheWorker) {
            return;
        }
        const messageData = {
            slots: [],
            queryKey,
            updatedAtGt: updatedAtGtToSave,
        };
        const allSlots = [];
        for (const [, s] of this.slots) {
            allSlots.push(s);
        }
        allSlots.sort((a, b) => a.id - b.id);
        for (const s of allSlots) {
            // Limit slots passed to background to 300 as any data passed to other thread is copied via structuredClone().
            if (messageData.slots.length >= 300) {
                break;
            }
            if (!cursor || s.id > cursor) {
                messageData.slots.push(s);
                continue;
            }
        }
        if (!messageData.slots.length) {
            this.onCacheAllSlotsFinish(queryKey, updatedAtGtToSave);
            return;
        }
        this.slotCacheWorker.postMessage(messageData);
    }
    presentSlotsAndUsersReadOnly(allUsers, slots, filters) {
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore || !firstDate || !endTableDate) {
            return;
        }
        // Some callers may pass in slots that are before the view. Filter slots out that are before the view to not get incorrect stats.
        const { slots: filteredSlots } = filterFetchedSlotsForView(slots, firstDate.getDate().valueOf(), this.settings.splitNightShift, this.settings.getTimeZone());
        const filteredUsers = filterUsers(allUsers, filteredSlots, filters.workerOnly ?? false, filters.userTags, filters.roleIds, getBranchRoleIdSet(this.roleStore));
        const sortedUsers = sortUsers(filteredUsers, this.branch.employeeIds);
        this.initPresentationEmployeeRows(sortedUsers);
        const rawEmployments = [];
        for (const u of sortedUsers) {
            rawEmployments.push(dashUserToRawEmployment(u));
        }
        // Required for slot modal to fill in user values
        (0, summary_lib_1.setGlobalAppUserMap)(calcAppUserMap(sortedUsers));
        const filteredUserSet = new Set();
        for (const u of filteredUsers) {
            this.userIdsInView.push(u.userId);
            filteredUserSet.add(u.userId);
        }
        const rawSlots = [];
        // Use the unfiltered slots to populate slot map and cells map. Required for weekly work limit.
        for (const s of slots) {
            if (!filteredUserSet.has(s.userId)) {
                continue;
            }
            rawSlots.push(dashSlotToRawShift(s, this.settings, firstDate.getDate(), endTableDate.getEnd(), this.settings.getTimeZone()));
        }
        const slotMap = calcSlotMap([...rawSlots, ...this.templates]);
        Object.assign(this.slotMap, slotMap);
        (0, summary_lib_1.setSlotMap)(slotMap);
        const splitNightShift = this.settings.splitNightShift;
        const cellsMap = {};
        (0, employmentShiftTable_1.buildCellsMap)(cellsMap, slotMap, (0, common_1.toOplusTime)(endTableDate.getDate()), filters.isLocked ?? false, splitNightShift, this.settings.getTimeZone());
        this.cellsMap.value = cellsMap;
        if (splitNightShift) {
            const nightMergedCellsMap = {};
            (0, employmentShiftTable_1.buildCellsMap)(nightMergedCellsMap, slotMap, (0, common_1.toOplusTime)(endTableDate.getDate()), filters.isLocked ?? false, false, this.settings.getTimeZone());
            this.nightMergedCellsMap.value = nightMergedCellsMap;
        }
        this.initStats(rawEmployments, filteredSlots);
    }
    presentSlotDeletes(slots, startDate, endDate, calcStats) {
        if (!this.settings) {
            return;
        }
        for (const slot of slots) {
            const rawSlot = dashSlotToRawShift(slot, this.settings, startDate, endDate, this.settings.getTimeZone());
            if (calcStats) {
                this.updateStatsOnRawSlotDelete(rawSlot);
            }
            const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone());
            // Must remove from cells map before slot map
            for (const d of dates) {
                const cell = this.cellsMap.value[rawSlot.UserID]?.[d];
                if (cell) {
                    delete cell.slots[rawSlot.ID];
                }
            }
            delete this.slotMap[rawSlot.ID];
        }
    }
    presentSlotUpdates(slots, previousSlots, filteredUserSet, startDate, endDate, calcStats) {
        if (!this.settings) {
            return;
        }
        for (const s of slots) {
            // If user is not in view, do not add slot to view models.
            if (!filteredUserSet.has(s.userId)) {
                continue;
            }
            // If changed date or user, we need to manually delete previous slot
            const prev = previousSlots.get(s.id);
            if (prev && (prev.userId !== s.userId || prev.date !== s.date)) {
                const prevRaw = this.slotMap[prev.id];
                if (prevRaw) {
                    if (calcStats) {
                        this.updateStatsOnRawSlotDelete(prevRaw);
                    }
                    const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(prevRaw, this.settings.getTimeZone());
                    for (const d of dates) {
                        const cell = this.cellsMap.value[prevRaw.UserID]?.[d];
                        if (cell) {
                            delete cell.slots[prevRaw.ID];
                        }
                    }
                }
            }
            const rawSlot = dashSlotToRawShift(s, this.settings, startDate, endDate, this.settings.getTimeZone());
            this.updateStatsOnRawSlotChange(rawSlot);
            this.handleSpecialCellsMapConditions(rawSlot, this.slotMap[rawSlot.ID]);
            // Add to slot map.
            this.slotMap[rawSlot.ID] = (0, vue_1.toRaw)(rawSlot);
            rawSlot.SectionSlots?.forEach(section => {
                this.slotMap[section.ID] = (0, vue_1.toRaw)(section);
            });
            // Must set global slot map before cells map.
            this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        }
        (0, summary_lib_1.setSlotMap)(this.slotMap);
    }
    presentSlotsAndUsers(allUsers, slots, filters) {
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore || !firstDate || !endTableDate) {
            return;
        }
        // Pass unfiltered slots.
        this.presentSlotsAndUsersReadOnly(allUsers, slots, filters);
        // Some callers may pass in slots that are before the view. Filter slots out that are before the view to not get incorrect stats.
        const { slots: filteredSlots } = filterFetchedSlotsForView(slots, firstDate.getDate().valueOf(), this.settings.splitNightShift, this.settings.getTimeZone());
        const filteredUsers = filterUsers(allUsers, filteredSlots, filters.workerOnly ?? false, filters.userTags, filters.roleIds, getBranchRoleIdSet(this.roleStore));
        const sortedUsers = sortUsers(filteredUsers, this.branch.employeeIds);
        const sortedUserIds = sortedUsers.map(du => du.userId);
        this.editModeCellProps.value = computeEditModeCellProps(this.tableDates, sortedUserIds, this.settings.getTimeZone());
        const filteredUserSet = new Set(sortedUserIds);
        const rawSlots = [];
        for (const s of filteredSlots) {
            if (!filteredUserSet.has(s.userId)) {
                continue;
            }
            rawSlots.push(dashSlotToRawShift(s, this.settings, firstDate.getDate(), endTableDate.getEnd(), this.settings.getTimeZone()));
        }
        (0, summary_lib_1.toggleUnlockSlotBtn)(rawSlots);
    }
    calcStatsSync() {
        const firstDate = this.tableDates[0]?.getDate();
        const endTableDate = this.tableDates[this.tableDates.length - 1]?.getEnd();
        if (!this.shiftStore || !firstDate || !endTableDate || !this.settings) {
            return;
        }
        const statsSlots = [];
        for (const slotId in this.shiftStore.data) {
            const s = this.shiftStore.byId(slotId);
            if (!s || !isSlotInRange(s.getStartDate(), s.endDate, firstDate, endTableDate, this.settings.splitNightShift)) {
                continue;
            }
            statsSlots.push((0, employmentShiftTableStats_1.shiftToStatSlot)(s));
        }
        const stats = (0, employmentShiftTableStats_1.calcStatsForSlotsListSummaryWeeklyMonthlyCustom)(statsSlots, this.useSectionWage);
        this.applySlotStatsListToStats(stats);
        this.onCalcStatsFinish();
    }
    calcSplitNightStatsSync() {
        if (!this.summaryStats || !this.shiftStore || !this.settings) {
            return;
        }
        for (const slotId in this.shiftStore.data) {
            const s = this.shiftStore.byId(slotId);
            if (!s) {
                continue;
            }
            const { shift, options, doNotCalcStats } = (0, employmentShiftTable_1.getShiftAndOptionsForStats)(s, this.shiftStore, this.settings.splitNightShift);
            if (doNotCalcStats) {
                continue;
            }
            this.summaryStats.handleShiftChange(shift, options);
        }
    }
    renderStats() {
        if (!this.branch) {
            return;
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
    }
    renderDeferrableDOMManipulations(props) {
        if (!this.branch || !this.roleStore || !this.meStore) {
            return;
        }
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!firstDate || !endTableDate) {
            return;
        }
        const slots = [];
        for (const [, s] of this.slots) {
            slots.push(s);
        }
        const allUserTags = calcDedupedTagsListFromUsers(this.users);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        // Following should only be inited once we have fresh data.
        // Always include all tags, even for staff not shown.
        const tagsProp = (0, common_1.sortTags)(calcTagsProp(allUserTags, userTagsFilters));
        const roles = this.roleStore.query({ isOrRole: true, excludeOrRole: true });
        const oplusTimeStart = (0, common_1.toOplusTime)(firstDate.getDate());
        const oplusTimeEnd = (0, common_1.toOplusTime)(endTableDate.getDate());
        (0, summary_lib_1.mountAutoModal)(props, roles, tagsProp, this.presenter);
        if (this.hasAutoPerm) {
            const autoAIRoles = this.roleStore.query({ isOrRole: true, excludeOrRole: true });
            (0, summary_lib_1.mountAutoAIModal)(props, autoAIRoles, oplusTimeStart, oplusTimeEnd, tagsProp, this.meStore, this.presenter);
            (0, autoai_poll_1.initFooterAutoButtonClick)();
        }
        (0, summary_lib_1.mountSummaryDateNavView)(props, oplusTimeStart, oplusTimeEnd, tagsProp, this.settings);
        (0, summary_lib_1.scrollToToday)();
        (0, summary_lib_1.setCalendarModal)();
        (0, employmentShiftTable_1.readSlots)(this.slotMap, this.meStore.me.getOriginalId());
    }
    updateStatsOnRawSlotChange(rawSlot) {
        if (!this.shiftStore || !this.summaryStats || !this.branch || !this.settings) {
            return;
        }
        const options = {
            prevShift: getShiftForStatsFromShiftStore(rawSlot.ID, this.shiftStore),
        };
        (0, employmentShiftTable_1.addRawSlotToShiftStore)(rawSlot, this.settings.getTimeZone(), this.tableDates, this.shiftStore, this.branch.id);
        const shift = this.shiftStore.byId(rawSlot.ID.toString());
        if (!shift) {
            return;
        }
        this.summaryStats.handleShiftChange(shift, options);
    }
    addSlotToCellsMapOnRawSlotChange(rawSlot) {
        if (!this.shiftStore || !this.settings) {
            return;
        }
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!firstDate || !endTableDate) {
            return;
        }
        const splitNightShift = this.settings.splitNightShift;
        if (rawSlot.Repeat) {
            (0, employmentShiftTable_1.renderRepeatSlots)(this.cellsMap.value, rawSlot, (0, common_1.toOplusTime)(endTableDate.getDate()), this.query.isLocked ?? false, splitNightShift, this.settings.getTimeZone());
            if (splitNightShift) {
                (0, employmentShiftTable_1.renderRepeatSlots)(this.nightMergedCellsMap.value, rawSlot, (0, common_1.toOplusTime)(endTableDate.getDate()), this.query.isLocked ?? false, false, this.settings.getTimeZone());
            }
            return;
        }
        const shift = this.shiftStore.byId(rawSlot.ID.toString());
        // Only add shifts are in view.
        if (!shift || !(0, common_2.timespansOverlap)(firstDate.getDate(), endTableDate.getEnd(), shift.getStartDate(), shift.getEndDate())) {
            return;
        }
        (0, employmentShiftTable_1.addSlotToCellsMap)(this.cellsMap.value, rawSlot, this.settings.splitNightShift, this.settings.getTimeZone());
        if (splitNightShift) {
            (0, employmentShiftTable_1.addSlotToCellsMap)(this.nightMergedCellsMap.value, rawSlot, false, this.settings.getTimeZone());
        }
    }
    handleSpecialCellsMapConditions(rawSlot, prev) {
        if (!this.settings) {
            return;
        }
        if (this.settings.splitNightShift && prev) {
            // Slot rendering in table when split night shift is on requires extra deletes when overnight slot becomes normal.
            const prevDates = (0, employmentShiftTable_1.getDateStringsForSlot)(prev, this.settings.getTimeZone());
            const curDates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone());
            if (prevDates.length > curDates.length) {
                for (const d of prevDates) {
                    const cell = this.cellsMap.value[prev.UserID]?.[d];
                    if (cell) {
                        delete cell.slots[prev.ID];
                    }
                }
            }
        }
        // A conversion to a requested slot requires deleting the previous request slot template.
        if (rawSlot.RequestedSlot) {
            const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone());
            for (const d of dates) {
                const cell = this.cellsMap.value[rawSlot.UserID]?.[d];
                if (cell) {
                    delete cell.slots[rawSlot.RequestedSlot.ID];
                }
            }
        }
    }
    async cacheSlot(s) {
        if (!this.summaryDb) {
            return;
        }
        try {
            await this.summaryDb.put(new storageSummary_1.DashSlotIndexedDB((0, storageSummary_1.dashSlotToCacheable)(s)));
        }
        catch (e) {
            console.error(`Failed to cache slot: ${e}`);
        }
    }
    // Because slot changes occur outside of app in components like slot modal,
    // handleSlotChange provides a way to pass those slots and update necessary stats and global vars.
    handleRawSlotChange(rawSlot) {
        if (!rawSlot || rawSlot.LinkNext || rawSlot.LinkPrev || !this.shiftStore || !this.branch || !this.settings || !this.summaryStats) {
            return;
        }
        // Update subject
        const ss = rawSlotToDashSlot(rawSlot);
        this.slots.set(ss.id, ss);
        this.upsertIntervalSourceSlot(ss);
        // Present
        this.updateStatsOnRawSlotChange(rawSlot);
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        this.handleSpecialCellsMapConditions(rawSlot, this.slotMap[rawSlot.ID]);
        // Add to slot map.
        this.slotMap[rawSlot.ID] = (0, vue_1.toRaw)(rawSlot);
        rawSlot.SectionSlots?.forEach(section => {
            this.slotMap[section.ID] = (0, vue_1.toRaw)(section);
        });
        // Must set global slot map before cells map.
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        (0, summary_lib_1.toggleUnlockSlotBtn)(Object.values(this.slotMap));
        // Do not await.
        this.cacheSlot(ss);
    }
    // DEPRECATED. Linked Slots as a feature are deprecated. Required for overnight role slots.
    handleStatsLinked(rawSlots) {
        if (!this.shiftStore || !this.settings || !this.branch || !this.summaryStats) {
            return;
        }
        if (!rawSlots[0]) {
            return;
        }
        let id = rawSlots[0].ID;
        if (!this.shiftStore.byId(rawSlots[0].ID.toString()) && rawSlots[1]) {
            id = rawSlots[1].ID;
        }
        const prev = getShiftForStatsFromShiftStore(id, this.shiftStore);
        // Add to store
        for (const s of rawSlots) {
            (0, employmentShiftTable_1.addRawSlotToShiftStore)(s, this.settings.getTimeZone(), this.tableDates, this.shiftStore, this.branch.id);
        }
        const options = {
            prevShift: prev,
            countAllPeriods: false,
            applyRestFieldToFirstPeriodOnly: false,
        };
        // Special treatment for linked and calc stats
        for (const s of rawSlots) {
            let shift = this.shiftStore.byId(s.ID.toString());
            if (!shift) {
                return;
            }
            // NOTE: Issues with Shift classes require use of "as".
            if (shift.isLinkedShift()) {
                let night, morning;
                if (shift.isMorningShift()) {
                    morning = shift;
                    night = this.shiftStore.byId(shift.getLinkedId());
                }
                else {
                    night = shift;
                    morning = this.shiftStore.byId(shift.getLinkedId());
                }
                if (morning && night) {
                    // Only calc stats for merged shift once, if both shift are in view.
                    if (morning.getId() === shift.getId()) {
                        return;
                    }
                    shift = (0, employmentShiftTable_1.mergeLinkedShifts)(morning, night);
                    options.countAllPeriods = true;
                    options.applyRestFieldToFirstPeriodOnly = true;
                }
            }
            this.summaryStats.handleShiftChange(shift, options);
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
    }
    updateStatsOnRawSlotDelete(rawSlot, repeatDate) {
        if (!this.shiftStore || !this.summaryStats) {
            return;
        }
        let shift = this.shiftStore.byId(rawSlot.ID.toString());
        if (rawSlot.Repeat) {
            // For now, we get date of the repeat from the modal to delete only the "extracted" shift.
            // In the future, slot modal should pass the deleted slot entity / feId so we don't need to query.
            if (!repeatDate) {
                return;
            }
            const max = (0, table_1.endDateForPeriod)(repeatDate, periodTypes_1.default.DAY, "Asia/Tokyo");
            const res = this.shiftStore.query({ repeatTemplateId: rawSlot.ID.toString(), startDateMin: repeatDate, startDateMax: max });
            shift = res[0];
        }
        if (!shift) {
            return;
        }
        let statsShift = shift;
        const options = {
            isDelete: true,
            countAllPeriods: false,
        };
        // NOTE: Issues with Shift classes require use of "as".
        if (shift.isLinkedShift()) {
            let night, morning;
            if (shift.isMorningShift()) {
                morning = shift;
                night = this.shiftStore.byId(shift.getLinkedId());
            }
            else {
                night = shift;
                morning = this.shiftStore.byId(shift.getLinkedId());
            }
            if (morning && night) {
                // Only calc stats for merged shift once, if both shift are in view.
                if (morning.getId() === shift.getId()) {
                    return;
                }
                statsShift = (0, employmentShiftTable_1.mergeLinkedShifts)(morning, night);
                options.countAllPeriods = true;
            }
        }
        this.summaryStats.handleShiftChange(statsShift, options);
        if (statsShift.isMergedShift()) {
            this.shiftStore.delete(statsShift.getMorningShiftId());
            this.shiftStore.delete(statsShift.getNightShiftId());
            return;
        }
        this.shiftStore.delete(shift.getId());
    }
    handleRawSlotDelete(rawSlot, oplusTimeUnix) {
        if (!rawSlot || !this.shiftStore || !this.summaryStats || !this.branch || !this.settings) {
            return;
        }
        // Update subject
        this.slots.delete(rawSlot.ID);
        this.deleteIntervalSourceSlot(rawSlotToDashSlot(rawSlot));
        // Present
        const repeatDate = oplusTimeUnix ? (0, common_1.fromOplusTime)(new Date(oplusTimeUnix * 1000)) : undefined;
        this.updateStatsOnRawSlotDelete(rawSlot, repeatDate);
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(rawSlot, this.settings.getTimeZone(), repeatDate);
        // Must remove from cells map before slot map
        for (const d of dates) {
            const cell = this.cellsMap.value[rawSlot.UserID]?.[d];
            if (cell) {
                delete cell.slots[rawSlot.ID];
            }
        }
        if (!rawSlot.Repeat) {
            delete this.slotMap[rawSlot.ID];
            (0, summary_lib_1.setSlotMap)(this.slotMap);
        }
        // Do not await.
        this.deleteSlotsFromCache([rawSlot.ID]);
    }
    // cacheAllSlots will cache all of the slots in the this.slots map.
    // If the cache worker is available, it will prefer a series of batched background tasks.
    // If not, it will perform a single task on the main thread.
    async cacheAllSlots(queryKey, updatedAtGtToSave) {
        if (!this.settings || !this.branch) {
            return;
        }
        if (this.slotCacheWorker) {
            this.cacheSlotsBatchedBackground(queryKey, updatedAtGtToSave);
        }
        else {
            // Use main thread put.
            const allSlots = [];
            for (const [, s] of this.slots) {
                allSlots.push(s);
            }
            try {
                await (0, storageSummary_1.cacheSlots)(allSlots, queryKey);
                await this.onCacheAllSlotsFinish(queryKey, updatedAtGtToSave);
            }
            catch (e) {
                console.error(`Failed to cache all slots sync: ${e}`);
            }
        }
    }
    async onCacheAllSlotsFinish(queryKey, updatedAtGtToSave) {
        if (updatedAtGtToSave) {
            try {
                await this.summaryDb?.put(new storageSummary_1.SlotQuery(queryKey, updatedAtGtToSave.toISOString()));
            }
            catch (e) {
                console.error(e);
            }
        }
        await this.enforceSlotCacheLimit();
    }
    // handleRawSlotsLocked handles updating the slot subject and presenting slots after a bulk lock.
    // Currently the function assumes that a lock event is only a visual change, so stats are not computed.
    handleRawSlotsLocked(rawSlots) {
        const dashSlots = [];
        for (const rawSlot of rawSlots) {
            dashSlots.push(rawSlotToDashSlot(rawSlot));
            // Present
            this.slotMap[rawSlot.ID] = (0, vue_1.toRaw)(rawSlot);
            this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        }
        this.addSlotsToSlotMap(dashSlots);
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        (0, summary_lib_1.toggleUnlockSlotBtn)(Object.values(this.slotMap));
        // Do not await.
        if (this.summaryDb) {
            const toPut = [];
            for (const s of dashSlots) {
                toPut.push(new storageSummary_1.DashSlotIndexedDB((0, storageSummary_1.dashSlotToCacheable)(s)));
            }
            this.summaryDb.putAll(toPut);
        }
    }
    handleRawSlotDrag(rawSlot) {
        if (!this.settings || !this.branch) {
            return;
        }
        const prev = this.slotMap[rawSlot.ID];
        if (prev) {
            this.updateStatsOnRawSlotDelete(prev);
            const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(prev, this.settings.getTimeZone());
            for (const d of dates) {
                const cell = this.cellsMap.value[prev.UserID]?.[d];
                if (cell) {
                    delete cell.slots[prev.ID];
                }
            }
        }
        const ss = rawSlotToDashSlot(rawSlot);
        this.slots.set(ss.id, ss);
        this.upsertIntervalSourceSlot(ss);
        this.slotMap[ss.id] = (0, vue_1.toRaw)(rawSlot);
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        this.updateStatsOnRawSlotChange(rawSlot);
        this.addSlotToCellsMapOnRawSlotChange(rawSlot);
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        // Do not await.
        this.cacheSlot(ss);
    }
    handleRawSlotsBulkSelectedDelete(slotIds) {
        if (!this.branch || !this.settings) {
            return;
        }
        for (const id of slotIds) {
            this.slots.delete(id);
            const s = this.slotMap[id];
            if (!s) {
                continue;
            }
            this.deleteIntervalSourceSlot(rawSlotToDashSlot(s));
            if (s?.RequestedSlot) {
                // Restore initial requested slot.
                this.handleRawSlotChange(s.RequestedSlot);
            }
            this.updateStatsOnRawSlotDelete(s);
            const dates = (0, employmentShiftTable_1.getDateStringsForSlot)(s, this.settings.getTimeZone());
            // Must remove from cells map before slot map
            for (const d of dates) {
                const cell = this.cellsMap.value[s.UserID]?.[d];
                if (cell) {
                    delete cell.slots[s.ID];
                }
            }
            delete this.slotMap[s.ID];
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        // Do not await.
        this.deleteSlotsFromCache(slotIds);
    }
    handleRawSlotsBulkDelete(slotIds) {
        if (!this.branch || !this.settings) {
            return;
        }
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!firstDate || !endTableDate) {
            return;
        }
        for (const id of slotIds) {
            this.slots.delete(id);
            const s = this.slotMap[id];
            if (s) {
                this.deleteIntervalSourceSlot(rawSlotToDashSlot(s));
                this.updateStatsOnRawSlotDelete(s);
            }
            delete this.slotMap[id];
        }
        (0, summary_lib_1.setSlotMap)(this.slotMap);
        this.cellsMap.value = {};
        const splitNightShift = this.settings.splitNightShift;
        (0, employmentShiftTable_1.buildCellsMap)(this.cellsMap.value, this.slotMap, (0, common_1.toOplusTime)(endTableDate.getDate()), this.query.isLocked ?? false, splitNightShift, this.settings.getTimeZone());
        if (splitNightShift) {
            this.nightMergedCellsMap.value = {};
            (0, employmentShiftTable_1.buildCellsMap)(this.nightMergedCellsMap.value, this.slotMap, (0, common_1.toOplusTime)(endTableDate.getDate()), this.query.isLocked ?? false, false, this.settings.getTimeZone());
        }
        (0, summary_common_1.renderAllStatsColumns)(this.tableDates, this.summaryStats, this.roleStore, this.roleCountData, this.settings?.overtimeStartTime, this.canViewSpotWork);
        (0, summary_common_1.renderAllStatsRows)(this.summaryStats, this.employmentStore, this.roleStore, this.branch.id);
        // Do not await.
        this.deleteSlotsFromCache(slotIds);
    }
    initStats(users, slots) {
        if (!this.settings || !this.meStore || !this.roleStore || !this.branch) {
            return;
        }
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!firstDate || !endTableDate) {
            return;
        }
        const empStore = (0, employmentShiftTable_1.newEmploymentStoreFromRaw)(users, this.branch?.id);
        this.employmentStore = empStore;
        const repeatMap = new Map();
        const shiftStore = new shiftStore_1.ShiftStore();
        for (const s of slots) {
            if (s.isRepeat) {
                const prev = repeatMap.get(s.id);
                // Final repeat instances should be cloned from the earliest repeat instance in view.
                if (prev && new Date(prev.from) < new Date(s.from)) {
                    continue;
                }
                repeatMap.set(s.id, s);
            }
            const rawSlot = dashSlotToRawShift(s, this.settings, firstDate.getDate(), endTableDate.getEnd(), this.settings.getTimeZone());
            (0, employmentShiftTable_1.addRawSlotToShiftStore)(rawSlot, this.settings.getTimeZone(), this.tableDates, shiftStore, this.branch.id);
        }
        this.shiftStore = shiftStore;
        const stats = (0, employmentShiftTable_1.newSummaryStats)(this.roleStore, empStore, shiftStore, this.meStore, this.tableDates, this.settings, this.settings.getTimeZone(), this.useSectionWage);
        this.summaryStats = stats;
    }
    applySlotStatsListToStats(slotStats) {
        if (!this.shiftStore || !this.employmentStore || !this.settings || !this.roleStore || !this.summaryStats) {
            return;
        }
        for (const ss of slotStats) {
            const slot = this.shiftStore.byId(ss.feId);
            if (!slot) {
                continue;
            }
            const employments = this.employmentStore.query({ userId: slot.getUserId(), branchId: slot.getBranchId() });
            // If we cannot find an employment, then we will be unable to interact with the stats map. Return.
            if (!employments[0] || employments.length > 1) {
                continue;
            }
            const employment = employments[0];
            // Summary stats map uses UTC ISO strings for indexes.
            const date = luxon_1.DateTime.fromJSDate(slot.getStartDate(), { zone: this.settings.getTimeZone() })
                .startOf('day')
                .setZone('UTC')
                .toISO();
            if (!date) {
                continue;
            }
            let role;
            if (slot.getRoleId()) {
                role = this.roleStore.byId(slot.getRoleId());
            }
            const cs = this.summaryStats.getStatsMap().getCellStats(date, employment.index());
            const shiftStats = (0, employmentShiftTableStats_1.slotStatsSendableToShiftStats)(ss);
            cs?.setSlotStats(slot.getStatsId(), shiftStats);
            const slotStatsDiff = (0, stats_1.calcSlotDiff)(shiftStats);
            const prevCellStats = cs?.getData();
            const cellStats = (0, employmentShiftTableStats_1.calcCellStatsFromDiff)(slotStatsDiff, prevCellStats, role, this.settings?.overtimeStartTimeHours);
            cs?.setData(cellStats);
            const cellStatsDiff = (0, stats_1.calcCellDiff)(prevCellStats ?? new shiftCellStats_1.ShiftCellStats(), cellStats, employment.getTransportCost());
            const prevRowStats = this.summaryStats.getStatsMap().getRowStats(employment.index())?.getData();
            const rowStats = (0, stats_1.calcRowStatsFromDiff)(cellStatsDiff, prevRowStats ?? new shiftRowStats_1.ShiftRowStats());
            this.summaryStats.getStatsMap().getRowStats(employment.index())?.setData(rowStats);
            const prevColumnStats = this.summaryStats.getStatsMap().getColumnStats(date)?.getData();
            const columnStats = (0, stats_1.calcColumnStatsFromDiff)(cellStatsDiff, prevColumnStats ?? new shiftColumnStats_1.ShiftColumnStats());
            this.summaryStats.getStatsMap().getColumnStats(date)?.setData(columnStats);
        }
    }
    // Cannot support split night shift nor linked slots.
    statsBgBatched(batch, isUsingCachedData) {
        if (!this.settings || !this.statsWorker || !this.shiftStore) {
            return;
        }
        const message = {
            useSectionWage: this.useSectionWage,
            slots: [],
            // Indicates the job is using cached data and so if we fetch new data before the task is complete, we should give up.
            // A job using new data will perform extra work on completion.
            isUsingCachedData,
        };
        // Assume there are no linked slots nor overnight settings.
        message.slots = calcStatsBatchFromShiftStore(this.shiftStore, batch);
        if (message.slots.length === 0) {
            return;
        }
        this.statsWorker.postMessage(message);
    }
    renderUserLaborBadges() {
        if (!this.canEdit || !this.branch || !this.tableDates.length || !this.settings || !this.summaryStats?.slotStore) {
            return;
        }
        const startDate = this.tableDates[0]?.getDate();
        const endDate = this.tableDates[this.tableDates.length - 1]?.getEnd();
        if (!startDate || !endDate) {
            return;
        }
        const slots = [];
        const cloneShifts = [];
        const userToCloneLaborHours = new Map();
        for (const [, s] of this.slots) {
            slots.push(s);
            if (s.branchId !== this.branch.id) {
                if (s.isRepeat) {
                    const shifts = (0, employmentShiftTable_1.calcRepeatShiftsFromRawTemplateForShiftStore)(dashSlotToRawShift(s, this.settings, startDate, endDate, this.settings?.getTimeZone()), this.settings.getTimeZone(), this.tableDates);
                    cloneShifts.push(...shifts);
                    if (shifts[0]?.isHideTo()) {
                        continue;
                    }
                    for (const shift of shifts) {
                        const laborHours = calcCloneLaborHours(shift, startDate, endDate);
                        if (!laborHours) {
                            continue;
                        }
                        const total = userToCloneLaborHours.get(s.userId) ?? 0;
                        userToCloneLaborHours.set(s.userId, total + laborHours);
                    }
                }
                else {
                    // For now, assume slot map has already been initialized and fail to find means we can ignore labor hours.
                    const rawSlot = this.slotMap[s.id];
                    if (!rawSlot) {
                        continue;
                    }
                    const shift = (0, employmentShiftTable_1.calcShiftForShiftStoreFromRaw)(rawSlot);
                    if (!shift) {
                        continue;
                    }
                    cloneShifts.push(shift);
                    const laborHours = calcCloneLaborHours(shift, startDate, endDate);
                    if (!laborHours) {
                        continue;
                    }
                    const total = userToCloneLaborHours.get(s.userId) ?? 0;
                    userToCloneLaborHours.set(s.userId, total + laborHours);
                }
            }
        }
        const allUserTags = calcDedupedTagsListFromUsers(this.users);
        const userTagsFilters = decodeTags(this.query.customEncodingUserTags, allUserTags);
        const filters = {
            roleIds: [],
            userTags: userTagsFilters,
            isLocked: this.query.isLocked,
            workerOnly: this.query.workerOnly,
        };
        const filteredUsers = filterUsers(this.users, slots, filters.workerOnly ?? false, filters.userTags, filters.roleIds, getBranchRoleIdSet(this.roleStore));
        const sortedUsers = sortUsers(filteredUsers, this.branch.employeeIds);
        const rawEmployments = [];
        for (const u of sortedUsers) {
            rawEmployments.push(dashUserToRawEmployment(u));
        }
        const allShifts = Object.values(this.summaryStats.slotStore.data).concat(cloneShifts);
        (0, summary_lib_1.initUserLaborBadges)(rawEmployments, this.summaryStats, this.meStore, this.employmentStore, this.viewType, this.branchDefaultMaxMonthly, allShifts, userToCloneLaborHours, this.branchDefaultMonthlyVacationLimit);
    }
    onCalcStatsFinish() {
        this.renderStats();
        const statsRows = document.querySelectorAll("tr.loading");
        for (const row of statsRows) {
            row.classList.remove("loading");
        }
    }
    onBgStatsFinish(allowWrites) {
        this.onCalcStatsFinish();
        if (allowWrites) {
            // Stats computation with fresh data completed. Allow slot editing.
            this.allowWrites();
            this.renderUserLaborBadges();
        }
        else {
            this.cachedStatsCompleted = true;
        }
    }
    allowWrites() {
        // Unlock slot bulk editing features once data has been fetched.
        const statsRows = document.querySelectorAll(".read-only-disable");
        for (const row of statsRows) {
            row.classList.remove("read-only-disable");
        }
        // Remove loading indicator
        const spinner = document.querySelector("#slots-spinner");
        spinner?.remove();
        // Allow slot edits in table
        this.isReadOnly.value = false;
    }
    provideMeStore(meStore) {
        this.meStore = meStore;
        this.viewApp.provide(provider_1.summaryTableMeStoreInjectKey, meStore);
    }
    provideUseShiftBorders(useShiftBorders) {
        // Not able to use inject keys
        this.viewApp.provide('useShiftBorders', useShiftBorders);
    }
    provideSlotLogMap(slotLogMap) {
        // Not able to use inject keys
        this.viewApp.provide('slotLogMap', (0, vue_1.computed)(() => slotLogMap));
    }
    provideCellEditMode(cellEditMode) {
        // Not able to use inject keys
        this.viewApp.provide('cellEditMode', (0, vue_1.computed)(() => cellEditMode));
    }
    provideDeleteMode(deleteMode) {
        // Not able to use inject keys
        this.viewApp.provide('deleteMode', (0, vue_1.computed)(() => deleteMode));
    }
    provideConfirmMode(confirmMode) {
        // Not able to use inject keys
        this.viewApp.provide('confirmMode', (0, vue_1.computed)(() => confirmMode));
    }
    provideBranchSettings(branchSettings) {
        this.settings = branchSettings;
        this.viewApp.provide(provider_1.summaryTableBranchSettingsInjectKey, branchSettings);
    }
    provideRoleStore(roleStore) {
        this.roleStore = roleStore;
        this.viewApp.provide('roleStore', roleStore);
    }
    initPresentation() {
        const viewModel = (0, vue_1.ref)({
            scheduleIntervals: [],
            employeeRows: [],
            oplusTimeDateStrings: [],
            hoveredUserId: 0,
            hoveredDate: "",
            canViewSpotWork: this.canViewSpotWork
        });
        this.presenter.setViewModel(viewModel.value);
        // Adding readonly(), which stops view from mutating view model, causes ts to report error: is 'readonly' and cannot be assigned to the mutable type 'SummaryTableEmployeeRow[]'.
        // It's a known typescript quirk (https://stackoverflow.com/questions/62225769/inconsistency-with-typescript-readonly-type) but doesn't appear in other repos. I am assuming it's a config issue.
        // Ignoring the typescript check for now as ignoring it makes the view model readonly and there doesn't seem to be any resulting type issues.
        // @ts-ignore
        this.viewApp.provide(provider_1.summaryTableViewModelInjectKey, (0, vue_1.readonly)(viewModel));
        this.viewApp.provide(provider_1.summaryTableIsReadOnlyInjectKey, (0, vue_1.readonly)(this.isReadOnly));
    }
    initPresentationEmployeeRows(userRows) {
        if (!this.branch) {
            return;
        }
        // Remove "/summary" from path
        const path = document.location.pathname.replace(/\/summary/ig, "");
        this.presenter.initEmployeeRows(userRows, this.showMemo, path, this.branch.id);
    }
    // initPresentationStats is a temporary way for summary_lib to pass required BE and computed values.
    // In the future, getting these values will be handled internally.
    initPresentationStats(roles, branchSettings, lockStatsColumns, showUserAlertBadges) {
        this.presenter.initEmployeeStats(branchSettings, lockStatsColumns, showUserAlertBadges, roles);
    }
    mount() {
        this.viewApp.mount("#summary-table-app");
    }
    clearBulkDelTimer() {
        if (this.timerBulkDelRequest) {
            clearTimeout(this.timerBulkDelRequest);
            this.timerBulkDelRequest = null;
        }
    }
    showSlotBulkDelLoading(show) {
        const btnEle = document.querySelector('#footer-delete-btn');
        if (show) {
            btnEle?.classList.add('loading');
        }
        else {
            btnEle?.classList.remove('loading');
        }
    }
    async fetchJson(url, options) {
        const res = await fetch(url, {
            credentials: "include",
            headers: {
                Accept: "application/json",
                ...(options?.headers ?? {}),
            },
            ...options,
        });
        if (!res.ok) {
            throw new Error(`Request failed: ${res.status}`);
        }
        return res.json();
    }
    initRetryCount() {
        this.cntSlotBulkDelStateReqRetry = 0;
    }
    scheduleBulkDelStateReq(stamp) {
        this.timerBulkDelRequest = setTimeout(() => {
            void this.getSlotBulkDelState(stamp);
        }, BULK_DELETE_POLL_INTERVAL_MS);
    }
    async getSlotBulkDelState(stamp) {
        if (!this.meStore) {
            return;
        }
        this.clearBulkDelTimer();
        const userId = this.meStore.getActiveUserId();
        const branchId = this.meStore.getActiveBranchId();
        try {
            const json = await this.fetchJson(`/dashboard/${userId}/summary/bulk_delete_state?c=${branchId}&stamp=${stamp}`, { method: "GET" });
            const { state } = json.result;
            if (!state) {
                this.initRetryCount();
                this.showSlotBulkDelLoading(false);
                (0, summary_lib_1.importAlertModal)().alert("シフト削除状況の取得に失敗しました。ページを更新して、再度お試しください。", false);
                return;
            }
            if (state === SlotBulkDeleteState.Done) {
                window.location.reload();
                return;
            }
            if (state === SlotBulkDeleteState.Inprogress) {
                this.initRetryCount();
                this.scheduleBulkDelStateReq(stamp);
                return;
            }
            if (this.cntSlotBulkDelStateReqRetry > BULK_DELETE_POLL_RETRY_LIMIT) {
                this.initRetryCount();
                this.showSlotBulkDelLoading(false);
                (0, summary_lib_1.importAlertModal)().alert("シフト削除状況の取得に失敗しました。ページを更新して、再度お試しください。", false);
                return;
            }
            this.cntSlotBulkDelStateReqRetry++;
            this.scheduleBulkDelStateReq(stamp);
        }
        catch {
            this.showSlotBulkDelLoading(false);
            (0, summary_lib_1.importAlertModal)().alert("シフト削除状況の取得に失敗しました。ページを更新して、再度お試しください。", false);
        }
    }
    async bulkDeleteSlots(action) {
        if (!this.meStore) {
            return;
        }
        const meStore = this.meStore;
        const userId = meStore.getActiveUserId();
        const branchId = meStore.getActiveBranchId();
        const text = action === common_1.SlotBulkDeleteAction.All ? "全て" : "確定シフト以外";
        const finalText = `現在画面に表示されている" ${text} "のシフトデータが削除されますがよろしいですか？　＊一度削除するとこのアクションは取り消せません。先にExcelダウンロードでバックアップすることをオススメします。＊`;
        const url = `/dashboard/${userId}/summary/bulk_delete?c=${branchId}`;
        const alertModal = (0, summary_lib_1.importAlertModal)(); // AlertModal() is of type any so this is temporary use and should be typed properly asap.
        alertModal.confirm(finalText, async () => {
            const excludedDates = this.presenter.getScheduleLockedDates();
            const firstDate = this.tableDates[0]?.getDate();
            if (firstDate && this.cellsMap && this.settings) {
                const outsideOfView = calcExcludedDateStrings(this.cellsMap.value, firstDate, this.settings?.getTimeZone());
                excludedDates.push(...outsideOfView);
            }
            const slotsToDelete = calcSlotIDsForBulkDelete(action, branchId, this.cellsMap?.value, this.slotMap, excludedDates);
            if (!slotsToDelete.length) {
                return;
            }
            const data = new URLSearchParams({
                selectedSlots: slotsToDelete.join(","),
            });
            try {
                this.clearBulkDelTimer();
                this.showSlotBulkDelLoading(true);
                const json = await this.fetchJson(url, {
                    method: "POST",
                    body: data,
                });
                const result = json.result;
                if (!result) {
                    this.showSlotBulkDelLoading(false);
                    alertModal.alert("エラーが発生しました。一部のシフトを削除できませんでした。ページを更新して、再度お試しください。", false);
                    return;
                }
                const { state, stamp } = result;
                if (state === SlotBulkDeleteState.Done) {
                    window.location.reload();
                    return;
                }
                this.scheduleBulkDelStateReq(stamp);
            }
            catch {
                this.showSlotBulkDelLoading(false);
                alertModal.alert("エラーが発生しました。一部のシフトを削除できませんでした。ページを更新して、再度お試しください。", false);
            }
        });
    }
    recalculateDurationBeforeLastShift() {
        if (!this.settings) {
            return;
        }
        const firstDate = this.tableDates[0];
        if (!firstDate) {
            return;
        }
        const firstVisibleDateMs = luxon_1.DateTime.fromJSDate(firstDate.getDate(), { zone: this.settings.getTimeZone() })
            .startOf("day")
            .toMillis();
        this.durationBeforeLastShiftBySlotId.value = calculateDurationBeforeLastShift(this.intervalSourceSlots, firstVisibleDateMs, this.settings.getTimeZone());
    }
    upsertIntervalSourceSlot(slot) {
        const matchIndex = this.intervalSourceSlots.findIndex((existingSlot) => {
            if (existingSlot.id !== slot.id) {
                return false;
            }
            if (existingSlot.isRepeat || slot.isRepeat) {
                return existingSlot.date === slot.date;
            }
            return true;
        });
        if (matchIndex >= 0) {
            this.intervalSourceSlots[matchIndex] = slot;
        }
        else {
            this.intervalSourceSlots.push(slot);
        }
        this.recalculateDurationBeforeLastShift();
    }
    deleteIntervalSourceSlot(slot) {
        this.intervalSourceSlots = this.intervalSourceSlots.filter((existingSlot) => {
            if (existingSlot.id !== slot.id) {
                return true;
            }
            if (existingSlot.isRepeat || slot.isRepeat) {
                return existingSlot.date !== slot.date;
            }
            return false;
        });
        this.recalculateDurationBeforeLastShift();
    }
    initAndProvideSpotStores() {
        this.spotShiftStore = (0, spotShiftStore_1.createSpotShiftStore)();
        this.spotWorkerStore = (0, spotWorkerStore_1.createSpotWorkerStore)();
        this.viewApp.provide(provider_2.spotShiftStoreKey, this.spotShiftStore);
        this.viewApp.provide(provider_2.spotWorkerStoreKey, this.spotWorkerStore);
        this.viewApp.provide(provider_2.loadSpotWorkerSummaryKey, this.loadSpotWorkerSummary.bind(this));
    }
    handleSpotShiftChange(statsDiff) {
        this.summaryStats?.handleSpotShiftChange(statsDiff);
        this.renderStats();
    }
    async loadSpotWorkerSummary() {
        if (this.spotWorkerSummaryLoaded) {
            return;
        }
        if (!this.spotWorkerSummaryLoad) {
            this.spotWorkerSummaryLoad = this.fetchSpotWorkerSummary().finally(() => {
                this.spotWorkerSummaryLoad = undefined;
            });
        }
        return this.spotWorkerSummaryLoad;
    }
    async fetchSpotWorkerSummary() {
        const firstDate = this.tableDates[0];
        const endTableDate = this.tableDates[this.tableDates.length - 1];
        if (!this.branch || !this.settings || !this.roleStore || !this.meStore || !firstDate || !endTableDate) {
            return;
        }
        // fetch one extra day to handle edge case for counting if interval from the previous shift exceeds threshold
        const actualFirstDate = firstDate.getDate();
        actualFirstDate.setDate(actualFirstDate.getDate() - 1);
        const endDate = endTableDate.getEnd();
        // Populate the stores with the shifts in the current summary and only the
        // workers referenced by those shifts.
        const params = {
            branchIds: [this.branch.id],
            startDate: actualFirstDate,
            endDate: endDate,
        };
        if (!this.spotShiftStore || !this.spotWorkerStore) {
            return;
        }
        this.spotShiftStore.setParams(params);
        while (!this.spotShiftStore.state.pagination.done) {
            await this.spotShiftStore.fetchNextPage();
        }
        const workerIds = [...new Set(Object.values(this.spotShiftStore.state.shifts)
                .map((shift) => shift.userId)
                .filter((userId) => userId > 0))];
        await this.spotWorkerStore.fetchWorkers(workerIds, this.branch.id);
        const stats = (0, useSpotWorkerStats_1.useSpotWorkerStats)(this.spotShiftStore, this.spotWorkerStore, this.roleStore);
        this.summaryStats?.addSummaryStatsToSpotWorkStats(stats.value);
        this.viewApp.provide(provider_2.handleSpotShiftChangeKey, this.handleSpotShiftChange.bind(this));
        this.spotWorkerSummaryLoaded = true;
        this.renderStats();
    }
}
exports.SummaryTableApp = SummaryTableApp;
function dashUserToRawEmployment(u) {
    return {
        ID: u.userId,
        BranchUser: {
            ID: u.branchUserId,
            BranchID: u.branchId,
            Wage: u.wage,
            Transport: u.transport,
            Memo: u.memo,
            Tags: u.tags.map(t => t.string),
            MaxMonthLaborMinutes: u.maxMonthLaborMinutes,
            MonthlyVacationLimit: u.maxMonthVacationDays,
            MinMonthLaborMinutes: u.minMonthLaborMinutes,
            MinWeekLaborMinutes: u.minWeekLaborMinutes,
            MaxWeekLaborMinutes: u.maxWeekLaborMinutes,
            Permission: "", // Unused on summary
            EmployeeID: "", // Unused on summary
            MonthlyLimit: 0, // Unused on summary
            BranchName: "", // Unused on summary
        }
    };
}
// sortUsers sorts the list of users into the passed order with remaining users appended to the end of list by name alphabetical asc.
function sortUsers(users, userIdOrder) {
    const userMap = new Map();
    for (const u of users) {
        userMap.set(u.userId, u);
    }
    const out = [];
    userIdOrder.forEach(id => {
        const u = userMap.get(id);
        if (!u) {
            return;
        }
        userMap.delete(id);
        out.push(u);
    });
    const help = [];
    // Remaining are help.
    for (const [, user] of userMap) {
        help.push(user);
    }
    // Sort help by name asc to match previous BE sorting.
    help.sort((a, b) => a.name > b.name ? 1 : -1);
    out.push(...help);
    return out;
}
const MAX_BATCH_SIZE = 1000;
const MAX_REQUEST_COUNT = 10;
async function fetchAllUsers(branchId, userIds, year, month) {
    const all = [];
    let requests = 0;
    for (let i = 0; i < userIds.length; i += MAX_BATCH_SIZE) {
        if (requests >= MAX_REQUEST_COUNT) {
            // Basic defensive code to stop from over-requesting.
            console.error("Reached maximum allowed user fetches.");
            break;
        }
        const batch = userIds.slice(i, i + MAX_BATCH_SIZE);
        const { dashUsers } = await (0, summary_1.getDashUsersForIds)(branchId, batch, year, month);
        all.push(...dashUsers);
        requests++;
    }
    return all;
}
async function fetchAllDashSlots(branchId, startDate, endDate, roleIds, lockedOnly) {
    const options = {
        branchId,
        fromGte: startDate,
        fromLt: endDate,
        lockedOnly,
        roleIds,
    };
    let requestCount = 0;
    let isDone = false;
    let cursor = "";
    const allSlots = [];
    const allIds = [];
    // Basic defensive code to stop from over-requesting.
    while (!isDone && requestCount < MAX_REQUEST_COUNT) {
        const { slots, page, ids } = await (0, summary_1.getSlots)(options, cursor);
        isDone = page.done;
        cursor = page.cursor;
        allSlots.push(...slots);
        allIds.push(...ids);
        requestCount++;
    }
    if (!isDone) {
        // Log an error for debugging.
        console.error("Reached maximum allowed slot fetches.");
    }
    return { slots: allSlots, ids: allIds };
}
function calcSlotMap(slots) {
    const slotMap = {};
    for (const s of slots) {
        // Keep earliest repeat instance
        const existingSlot = slotMap[s.ID];
        if (s.Repeat && existingSlot && new Date(existingSlot.From) < new Date(s.From)) {
            continue;
        }
        slotMap[s.ID] = (0, vue_1.toRaw)(s);
        if (s.SectionSlots) {
            for (const sec of s.SectionSlots) {
                slotMap[sec.ID] = (0, vue_1.toRaw)(sec);
            }
        }
    }
    return slotMap;
}
function dashSlotToShift(ds) {
    const req = {
        id: ds.id,
        type: ds.type,
        userId: ds.userId,
        branchId: ds.branchId,
        startDate: (0, common_1.fromOplusTime)(new Date(ds.from)),
        endDate: (0, common_1.fromOplusTime)(new Date(ds.to)),
    };
    const opt = {
        roleId: ds.roleId,
        roleName: ds.roleName,
        isEdited: ds.isEdited,
        isAuto: ds.isAuto,
        isTemplate: false,
        purpose: ds.purpose,
        updated: new Date(ds.updatedTimeUnix * 1000),
        created: new Date(ds.createdTimeUnix * 1000),
        hideFrom: ds.hideFrom,
        hideTo: ds.hideTo,
        createdBy: ds.createdBy,
    };
    return new shift_2.Shift(req, opt);
}
function dashSlotToRawShift(ds, settings, startDate, endDate, tz) {
    const sections = [];
    for (const section of ds.sectionSlots) {
        sections.push(dashSlotToRawShift(normalizeSectionToParentDate(section, ds, tz), settings, startDate, endDate, tz));
    }
    return {
        ID: ds.id,
        UserID: ds.userId,
        From: ds.from,
        To: ds.to,
        Type: ds.type,
        LinkPrev: ds.linkPrev,
        LinkNext: ds.linkNext,
        RoleID: ds.roleId,
        RoleName: ds.roleName,
        Sections: ds.sectionIds,
        CompanyID: ds.branchId,
        GroupID: ds.groupId,
        SectionSlots: sections,
        SectionParent: ds.parentSlotId,
        HideTo: ds.hideTo,
        HideFrom: ds.hideFrom,
        Rest: (0, common_1.durationToKitchenTime)(ds.rest, "minutes"),
        Repeat: ds.isRepeat,
        RepeatKey: ds.repeatKey,
        RepeatUntil: ds.repeatUntil,
        RepeatExclude: ds.repeatExclude,
        CreatedTime: ds.createdTime,
        CreatedTimeUnix: ds.createdTimeUnix,
        UpdatedTime: ds.updatedTime,
        UpdatedTimeUnix: ds.updatedTimeUnix,
        Purpose: ds.purpose,
        IsAuto: ds.isAuto,
        IsEdited: ds.isEdited,
        IsTemplate: false,
        Date: ds.date,
        RepeatLocked: ds.repeatLocked,
        CreatedBy: ds.createdBy,
        Wage: ds.wage,
        Color: ds.color,
        Locked: ds.isLocked,
        Memo: ds.memo,
        Label: ds.label,
        FromLabel: ds.fromLabel,
        FromUnix: ds.fromUnix,
        ToUnix: ds.toUnix,
        ToLabel: ds.toLabel,
        DateLabel: ds.dateLabel,
        DateUnix: ds.dateUnix,
        RequestedSlot: ds.requestedSlot ? dashSlotToRawShift(ds.requestedSlot, settings, startDate, endDate, tz) : undefined,
        Alert: ds.alert,
        AskStatus: ds.askStatus,
        IsHelp: ds.isHelp,
        KOTSynced: ds.isKotSynced,
        RequestedSlotKey: ds.requestedSlotKey,
        ManagedSlotKey: ds.managedSlotKey,
        RequestedSlotID: ds.requestedSlotId,
        ManagedSlotID: ds.managedSlotId,
        Text: (0, shift_1.shiftName)(dashSlotToShift(ds), settings, startDate, endDate, tz), // Required for sections in the SlotModal.
        NumComments: ds.numComments,
        IsRead: ds.isRead,
        CompanyName: ds.branchName, // Required for Help
    };
}
// Repeated parent slots are generated for each occurrence date, while their
// section records may retain the date from the original repeated slot. Keep
// the section's branch-local times and align both endpoints with the generated
// parent's branch-local start date.
function normalizeSectionToParentDate(section, parent, tz) {
    const normalizedFromTimestamp = normalizeSectionTimestamp(section.from, parent.from, tz);
    const normalizedToTimestamp = normalizeSectionTimestamp(section.to, parent.to, tz);
    const parentStart = luxon_1.DateTime.fromISO(parent.from, { zone: tz });
    const sectionFrom = luxon_1.DateTime.fromISO(section.from, { zone: tz });
    const sectionTo = luxon_1.DateTime.fromISO(section.to, { zone: tz });
    if (!parentStart.isValid || !sectionFrom.isValid || !sectionTo.isValid) {
        return section;
    }
    // Sections that are already close to the parent are valid, including
    // overnight sections. Only repair records that are clearly from another
    // occurrence; normalize both endpoints together below.
    if (normalizedFromTimestamp === section.from && normalizedToTimestamp === section.to) {
        return section;
    }
    let normalizedFromLocal = sectionFrom.set({
        year: parentStart.year,
        month: parentStart.month,
        day: parentStart.day,
    });
    let normalizedToLocal = sectionTo.set({
        year: parentStart.year,
        month: parentStart.month,
        day: parentStart.day,
    });
    // Shift both endpoints together so an overnight section keeps its original
    // local duration instead of turning into a 25-hour interval.
    if (normalizedFromLocal.toMillis() < parentStart.toMillis()) {
        normalizedFromLocal = normalizedFromLocal.plus({ days: 1 });
        normalizedToLocal = normalizedToLocal.plus({ days: 1 });
    }
    if (normalizedToLocal.toMillis() < normalizedFromLocal.toMillis()) {
        normalizedToLocal = normalizedToLocal.plus({ days: 1 });
    }
    const normalizedFrom = normalizedFromLocal.toUTC().toISO();
    const normalizedTo = normalizedToLocal.toUTC().toISO();
    if (!normalizedFrom || !normalizedTo) {
        return section;
    }
    if (normalizedFrom === section.from && normalizedTo === section.to &&
        section.date === parentStart.toFormat("yyyy-MM-dd")) {
        return section;
    }
    return {
        ...section,
        from: normalizedFrom,
        to: normalizedTo,
        fromUnix: Math.floor(normalizedFromLocal.toSeconds()),
        toUnix: Math.floor(normalizedToLocal.toSeconds()),
        date: parentStart.toFormat("yyyy-MM-dd"),
        dateLabel: parent.dateLabel,
        dateUnix: parent.dateUnix,
    };
}
function normalizeSectionTimestamp(sectionTimestamp, parentTimestamp, tz) {
    const sectionDate = luxon_1.DateTime.fromISO(sectionTimestamp, { zone: tz });
    const parentDate = luxon_1.DateTime.fromISO(parentTimestamp, { zone: tz });
    const dayMs = 24 * 60 * 60 * 1000;
    if (!sectionDate.isValid || !parentDate.isValid ||
        Math.abs(sectionDate.toMillis() - parentDate.toMillis()) <= dayMs) {
        return sectionTimestamp;
    }
    const normalized = sectionDate.set({
        year: parentDate.year,
        month: parentDate.month,
        day: parentDate.day,
    }).toUTC().toISO();
    return normalized || sectionTimestamp;
}
function filterUsersToWorkerOnly(users, slots) {
    const outUserIdSet = new Set();
    const workersOnly = [];
    const userMap = new Map();
    for (const u of users) {
        userMap.set(u.userId, u);
    }
    for (const s of slots) {
        if (outUserIdSet.has(s.userId) || (s.type !== models_1.SLOT_TYPES.HOURLY && s.type !== models_1.SLOT_TYPES.WORKDAY)) {
            continue;
        }
        const u = userMap.get(s.userId);
        if (!u) {
            continue;
        }
        workersOnly.push(u);
        outUserIdSet.add(s.userId);
    }
    return workersOnly;
}
function roleIdMatchesSummaryFilter(roleId, selectedRoleIds, branchRoleIds) {
    return selectedRoleIds === "all" ? branchRoleIds.has(roleId) : selectedRoleIds.has(roleId);
}
function getBranchRoleIdSet(roleStore) {
    return new Set((roleStore?.query({ filterRoleSection: true, isRoleSection: false }) ?? []).map(role => role.getOriginalId()));
}
// filterUsersToThoseWithRoleSlot expects a list of users and a list of role ids. Multiple role ids will result in OR operations, returning all users that have a slot of any role.
function filterUsersToThoseWithRoleSlot(users, slots, roleIds, branchRoleIds) {
    const outUserIdSet = new Set();
    const selectedRoleIds = roleIds === "all" ? "all" : new Set(roleIds);
    const activeBranchRoleIds = branchRoleIds ?? new Set();
    const out = [];
    const userMap = new Map();
    for (const u of users) {
        userMap.set(u.userId, u);
    }
    for (const s of slots) {
        const matchesRole = roleIdMatchesSummaryFilter(s.roleId, selectedRoleIds, activeBranchRoleIds);
        if (outUserIdSet.has(s.userId) || !matchesRole) {
            continue;
        }
        const u = userMap.get(s.userId);
        if (!u) {
            continue;
        }
        out.push(u);
        outUserIdSet.add(s.userId);
    }
    return out;
}
// filterUsersByTags expects a list of users and a list of decoded tags. Multiple tags will result in OR operations, returning all users that match any tag.
function filterUsersByTags(users, userTags) {
    const outUserIdSet = new Set();
    const out = [];
    const userTagSet = new Set(userTags);
    for (const u of users) {
        if (outUserIdSet.has(u.userId)) {
            continue;
        }
        for (const tag of u.tags) {
            if (userTagSet.has(tag.string)) {
                out.push(u);
                outUserIdSet.add(u.userId);
                break;
            }
        }
    }
    return out;
}
// filterUsers takes a list of users, removes any hidden users, and filters the list based on filters.
// Combinations of different filters are treated as AND operations.
function filterUsers(users, slots, workerOnly, userTags, roleIds, branchRoleIds) {
    const usersWithSlots = new Map();
    for (const slot of slots) {
        usersWithSlots.set(slot.userId, true);
    }
    let out = users.filter(u => !u.isHiddenInShift && !u.isSpotWorker && !(u.isDeleted && !usersWithSlots.get(u.userId)));
    if (!workerOnly && !userTags.length && roleIds !== "all" && !roleIds.length) {
        return out;
    }
    if (workerOnly) {
        out = filterUsersToWorkerOnly(users, slots);
    }
    if (userTags.length) {
        out = filterUsersByTags(out, userTags);
    }
    if (roleIds === "all" || roleIds.length) {
        out = filterUsersToThoseWithRoleSlot(out, slots, roleIds, branchRoleIds);
    }
    return out;
}
// filterFetchedSlotsForView will accept a list of slots, filtering out those that are before the current view. It will assume that the list does not includes slots after the view.
function filterFetchedSlotsForView(slots, firstVisibleDateMs, splitNightShift, timeZone) {
    const visibleSlots = [];
    const visibleIds = new Set();
    if (splitNightShift) {
        // For split overnight, we can show any slot that has a To time after the first table date.
        for (const slot of slots) {
            const toDateMs = (0, common_1.fromOplusTime)(new Date(slot.to)).valueOf();
            const fromDate = (0, common_1.fromOplusTime)(new Date(slot.from)).valueOf();
            if (toDateMs > firstVisibleDateMs || fromDate >= firstVisibleDateMs) {
                visibleSlots.push(slot);
                visibleIds.add(slot.id);
                continue;
            }
            // For repeat, "date" field may be before the first date. Add any repeats that overlap current view but were excluded in "date" check.
            if (slot.isRepeat && new Date(slot.repeatUntil).valueOf() > firstVisibleDateMs) {
                visibleSlots.push(slot);
                visibleIds.add(slot.id);
            }
        }
    }
    else {
        for (const slot of slots) {
            // For a standard view, we only show slots that start on or after the first table date.
            if (slot.date && luxon_1.DateTime.fromISO(slot.date, { zone: timeZone }).startOf("day").toMillis() >= firstVisibleDateMs) {
                visibleSlots.push(slot);
                visibleIds.add(slot.id);
                continue;
            }
            // For repeat, "date" field may be before the first date. Add any repeats that overlap current view but were excluded in "date" check.
            if (slot.isRepeat && new Date(slot.repeatUntil).valueOf() > firstVisibleDateMs) {
                visibleSlots.push(slot);
                visibleIds.add(slot.id);
            }
        }
    }
    return {
        slots: visibleSlots,
        ids: [...visibleIds],
    };
}
function calculateDurationBeforeLastShift(slots, firstVisibleDateMs, timeZone) {
    const userToDateToSummary = new Map();
    const durationBeforeLastShiftBySlotId = {};
    for (const slot of slots) {
        const isWorkingSlot = slot.type === models_1.SLOT_TYPES.HOURLY || slot.type === models_1.SLOT_TYPES.WORKDAY;
        if (slot.parentSlotId || !slot.date || !isWorkingSlot) {
            continue;
        }
        const fromMs = new Date(slot.from).valueOf();
        let dateToSummary = userToDateToSummary.get(slot.userId);
        if (!dateToSummary) {
            dateToSummary = new Map();
            userToDateToSummary.set(slot.userId, dateToSummary);
        }
        const daySummary = dateToSummary.get(slot.date) ?? {};
        if (!daySummary.latestSlot || fromMs > new Date(daySummary.latestSlot.from).valueOf()) {
            daySummary.latestSlot = slot;
        }
        if (!slot.linkPrev
            && luxon_1.DateTime.fromISO(slot.date, { zone: timeZone }).startOf("day").toMillis() >= firstVisibleDateMs
            && (!daySummary.earliestNonLinkSlot || fromMs < new Date(daySummary.earliestNonLinkSlot.from).valueOf())) {
            daySummary.earliestNonLinkSlot = slot;
        }
        dateToSummary.set(slot.date, daySummary);
    }
    for (const [, dateToSummary] of userToDateToSummary) {
        for (const [date, daySummary] of dateToSummary) {
            const earliestNonLinkSlot = daySummary.earliestNonLinkSlot;
            if (!earliestNonLinkSlot) {
                continue;
            }
            const prevDate = luxon_1.DateTime.fromISO(date, { zone: timeZone }).minus({ days: 1 }).toFormat("yyyy-MM-dd");
            const latestPrevSlot = dateToSummary.get(prevDate)?.latestSlot;
            if (!latestPrevSlot) {
                continue;
            }
            const slotDurations = durationBeforeLastShiftBySlotId[earliestNonLinkSlot.id] ?? {};
            slotDurations[date] = (new Date(earliestNonLinkSlot.from).valueOf() - new Date(latestPrevSlot.to).valueOf()) / 1000 / 60;
            durationBeforeLastShiftBySlotId[earliestNonLinkSlot.id] = slotDurations;
        }
    }
    return durationBeforeLastShiftBySlotId;
}
function prepareFetchedSlotsForView(slots, startDateForSlots, splitNightShift, timeZone) {
    const firstVisibleDateMs = luxon_1.DateTime.fromJSDate(startDateForSlots, { zone: timeZone }).startOf("day").toMillis();
    const durationBeforeLastShiftBySlotId = calculateDurationBeforeLastShift(slots, firstVisibleDateMs, timeZone);
    return {
        ...filterFetchedSlotsForView(slots, firstVisibleDateMs, splitNightShift, timeZone),
        durationBeforeLastShiftBySlotId,
    };
}
// calcUserIdsToFetch makes a list of user ids, always including all branch employees, adding in Help, and deduping
function calcUserIdsToFetch(employeeIds, slots) {
    // Always fetch all employees
    const userIdSet = new Set(employeeIds);
    for (const s of slots) {
        userIdSet.add(s.userId);
    }
    return [...userIdSet];
}
// calcTagsProp calculates a list of Tag entities used as props in various modals from a list of tags and decoded tags in location.search.
function calcTagsProp(tags, searchTags) {
    const out = [];
    const tagsSet = new Set();
    const selectedTags = new Set(searchTags);
    for (const t of tags) {
        if (tagsSet.has(t)) {
            continue;
        }
        tagsSet.add(t);
        out.push({
            decodedTag: t.string,
            selected: selectedTags.has(t.string),
            tag: t.encoded,
        });
    }
    return out;
}
// calcAppUserMap converts a list of users into the type required by the global App.userMap found in summary.html and required by the SlotModal in dashboard_base.html
function calcAppUserMap(users) {
    const userMap = {};
    for (const u of users) {
        userMap[u.userId] = {
            username: u.name,
        };
    }
    return userMap;
}
// parseSummaryQueryParams parses a URI encoded location.search string, returning relevant search params.
// Will ignore situations where the param key exists but the value is empty.
function parseSummaryQueryParams(searchString) {
    const out = {
        roleIds: [],
        customEncodingUserTags: []
    };
    const p = new URLSearchParams(searchString);
    const workerOnly = p.get("workerOnly");
    if (workerOnly) {
        out.workerOnly = workerOnly === "true";
    }
    const isLocked = p.get("lockedOnly");
    if (isLocked) {
        out.isLocked = isLocked === "true";
    }
    // Tags in search use custom encoding
    const tagsQ = p.get("tags");
    if (tagsQ) {
        for (const et of tagsQ.split(",")) {
            out.customEncodingUserTags.push(decodeURIComponent(et));
        }
    }
    const roleStr = p.get("roles");
    if (roleStr === "all") {
        out.roleIds = "all";
    }
    else if (roleStr && roleStr !== "0") {
        const roleIds = [];
        for (const id of roleStr.split(",")) {
            const n = Number(id);
            if (Number.isInteger(n) && n > 0) {
                roleIds.push(n);
            }
        }
        out.roleIds = roleIds;
    }
    return out;
}
// decodeTags expects a list of oplus custom encoding tags, returning a list of decoded strings.
function decodeTags(customEncodingTags, oplusTags) {
    const out = [];
    const customEncodingToDecodedTag = new Map();
    for (const t of oplusTags) {
        customEncodingToDecodedTag.set(t.encoded, t.string);
    }
    for (const customTag of customEncodingTags) {
        const decoded = customEncodingToDecodedTag.get(customTag);
        if (!decoded) {
            continue;
        }
        out.push(decoded);
    }
    return out;
}
function calcDedupedTagsListFromUsers(dashUsers) {
    const allUserTags = [];
    const tagSet = new Set();
    for (const u of dashUsers) {
        for (const t of u.tags) {
            if (tagSet.has(t.string)) {
                continue;
            }
            tagSet.add(t.string);
            allUserTags.push(t);
        }
    }
    return allUserTags;
}
// computeEditModeCellProps computes the grid props required by the edit mode.
function computeEditModeCellProps(dates, usersInOrder, tz) {
    const out = {};
    dates.forEach((date, dateIdx) => {
        const ds = (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(date.getDate()), tz);
        out[ds] = usersInOrder.map((userId, userIdx) => {
            const prevUserId = usersInOrder[userIdx - 1];
            const nextUserId = usersInOrder[userIdx + 1];
            const prevDate = dates[dateIdx - 1];
            const nextDate = dates[dateIdx + 1];
            return {
                userId: userId,
                prevUserId: prevUserId ? prevUserId : 0,
                nextUserId: nextUserId ? nextUserId : 0,
                prevDate: prevDate ? (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(prevDate.getDate()), tz) : "",
                nextDate: nextDate ? (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(nextDate.getDate()), tz) : "",
            };
        });
    });
    return out;
}
function rawSlotToDashSlot(raw) {
    const sectionSlots = [];
    if (raw.SectionSlots) {
        for (const section of raw.SectionSlots) {
            sectionSlots.push(rawSlotToDashSlot(section));
        }
    }
    return {
        id: raw.ID,
        from: raw.From,
        to: raw.To,
        type: raw.Type,
        purpose: raw.Purpose || "",
        hideFrom: raw.HideFrom,
        hideTo: raw.HideTo,
        isLocked: raw.Locked ?? false,
        rest: raw.Rest ? (0, common_1.kitchenTimeToDuration)(raw.Rest, "minutes") : 0,
        userId: raw.UserID,
        branchId: raw.CompanyID,
        groupId: raw.GroupID ?? 0,
        askStatus: raw.AskStatus ?? 0,
        createdTimeUnix: raw.CreatedTimeUnix ?? 0,
        updatedTimeUnix: raw.UpdatedTimeUnix ?? 0,
        color: raw.Color || "",
        commentCount: raw.NumComments ?? 0,
        sectionIds: raw.Sections ?? [],
        sectionSlots: sectionSlots,
        parentSlotId: raw.SectionParent ?? 0,
        isAuto: raw.IsAuto ?? false,
        isEdited: raw.IsEdited ?? false,
        isHelp: raw.IsHelp ?? false,
        isRead: raw.IsRead ?? false,
        isKotSynced: raw.KOTSynced ?? false,
        memo: raw.Memo ?? "",
        numComments: raw.NumComments ?? 0,
        roleId: raw.RoleID ?? 0,
        linkPrev: raw.LinkPrev ?? 0,
        linkNext: raw.LinkNext ?? 0,
        isRepeat: raw.Repeat,
        createdBy: raw.CreatedBy ?? 0,
        wage: raw.Wage ?? 0,
        alert: raw.Alert ?? 0,
        repeatKey: raw.RepeatKey,
        repeatUntil: raw.RepeatUntil,
        repeatExclude: raw.RepeatExclude ?? [],
        repeatLocked: raw.RepeatLocked ?? [],
        requestedSlotId: raw.RequestedSlotID ?? 0,
        requestedSlot: raw.RequestedSlot ? rawSlotToDashSlot(raw.RequestedSlot) : null,
        managedSlotId: raw.ManagedSlotID ?? 0,
        label: raw.Label || "",
        fromLabel: raw.FromLabel || "",
        fromUnix: raw.FromUnix || 0,
        toUnix: raw.ToUnix || 0,
        toLabel: raw.ToLabel ?? "",
        date: raw.Date,
        dateLabel: raw.DateLabel ?? "",
        dateUnix: raw.DateUnix ?? "",
        roleName: raw.RoleName ?? "",
        userName: "", // Deprecated. Unused.
        branchName: raw.CompanyName ?? "",
        createdTime: raw.CreatedTime ?? "",
        updatedTime: raw.UpdatedTime ?? "",
        requestedSlotKey: raw.RequestedSlotKey ?? "",
        managedSlotKey: raw.ManagedSlotKey ?? "",
    };
}
// NOTE: Issues with Shift classes require use of "as".
function getShiftForStatsFromShiftStore(id, shiftStore) {
    let shift = shiftStore.byId(id.toString());
    // Linked slots require special treatment for stats calculations.
    if (shift && shift.isLinkedShift()) {
        let night, morning;
        if (shift.isMorningShift()) {
            morning = shift;
            night = shiftStore.byId(shift.getLinkedId());
        }
        else {
            night = shift;
            morning = shiftStore.byId(shift.getLinkedId());
        }
        if (morning && night) {
            shift = (0, employmentShiftTable_1.mergeLinkedShifts)(morning, night);
        }
    }
    return shift;
}
function computeRoleCountData(pipelineValue) {
    const out = {
        rolesCount: {},
    };
    for (const role of pipelineValue) {
        const dates = {};
        for (const date of role.Dates) {
            dates[date.String] = {
                Required: date.Required,
            };
        }
        out.rolesCount[role.Role.ID] = {
            dates,
        };
    }
    return out;
}
function calcSlotsToDelete(slots, cachedSlots) {
    const freshSlots = new Set(slots);
    const slotsToDelete = new Set();
    // Slots are hard deleted so a comparison of full set is required to remove deleted slots from cache.
    for (const [, cachedSlot] of cachedSlots) {
        if (freshSlots.has(cachedSlot.id)) {
            continue;
        }
        slotsToDelete.add(cachedSlot.id);
    }
    return [...slotsToDelete];
}
// calcStatsIdBatches will creates batches of slot ids to use for stats batch calculating. Will filter out slots that are outside of the date range.
function calcStatsIdBatches(store, batchMax, firstDate, endDate, includeOvernight) {
    const out = [];
    batchMax = Math.max(1, batchMax);
    let currBatch = [];
    for (const slotId in store.data) {
        const s = store.byId(slotId);
        if (!s || !isSlotInRange(s.getStartDate(), s.endDate, firstDate, endDate, includeOvernight)) {
            continue;
        }
        if (currBatch.length >= batchMax) {
            out.push(currBatch);
            currBatch = [];
        }
        currBatch.push(slotId);
    }
    if (currBatch.length > 0) {
        out.push(currBatch);
    }
    return out;
}
// isSlotInRange will return if a slot should be shown and included in stats for a given date range. Only supports monthly, weekly, and custom ranges.
// Does not support Shift.GetEnd() when hideTo is true.
function isSlotInRange(slotStart, slotEnd, dateRangeStart, dateRangeEnd, includeOvernight) {
    if (includeOvernight) {
        return (0, common_1.timespansOverlapIncl)(slotStart, slotEnd, dateRangeStart, dateRangeEnd);
    }
    return slotStart >= dateRangeStart && slotStart <= dateRangeEnd;
}
function calcStatsBatchFromShiftStore(store, batchIds) {
    const out = [];
    for (const slotId of batchIds) {
        const s = store.byId(slotId);
        if (s) {
            out.push((0, employmentShiftTableStats_1.shiftToStatSlot)(s));
        }
    }
    return out;
}
function calcSlotIDsForBulkDelete(action, activeBranchId, cMap, slotMap, excludedDates) {
    if (!cMap || !slotMap || !excludedDates) {
        return [];
    }
    const slotsToDelete = [];
    const excludedDatesSet = new Set(excludedDates);
    for (const uId in cMap) {
        const userRowCells = cMap[uId];
        for (const dateString in userRowCells) {
            const userDateCell = userRowCells[dateString];
            if (!userDateCell) {
                continue;
            }
            for (const slotId in userDateCell.slots) {
                const slot = slotMap?.[slotId];
                if (!slot) {
                    continue;
                }
                if (slot.Repeat || slot.IsTemplate || String(slot.CompanyID) !== activeBranchId || slot.RepeatKey || excludedDatesSet.has(slot.Date)) {
                    continue;
                }
                if (action === common_1.SlotBulkDeleteAction.UnlockOnly && slot.Locked) {
                    continue;
                }
                slotsToDelete.push(slotId);
            }
        }
    }
    return slotsToDelete;
}
function calcMaxUpdatedAt(slots) {
    let max;
    for (const s of slots) {
        for (const section of s.sectionSlots) {
            if (!section.updatedAt) {
                continue;
            }
            const d = new Date(section.updatedAt);
            if (!max || d > max) {
                max = d;
            }
        }
        if (!s.updatedAt) {
            continue;
        }
        const d = new Date(s.updatedAt);
        if (!max || d > max) {
            max = d;
        }
    }
    return max;
}
function calcCloneLaborHours(shift, startDate, endDate) {
    if (shift.isHideTo()) {
        return 0;
    }
    const { laborHours } = (0, stats_1.calcShiftStats)(shift, startDate, endDate, {
        ignoreRestSections: false,
        ignoreRestField: false,
        ignoreRole: true,
        ignoreTransport: true,
        ignoreLaborHours: false,
        hourlyWage: 0,
        ptoHours: 0,
        useSectionWage: false,
    });
    return laborHours;
}
function calcExcludedDateStrings(cellsMap, firstDate, tz) {
    const out = new Set();
    const users = Object.values(cellsMap);
    for (const user of users) {
        const dateStrings = Object.keys(user);
        for (const dateString of dateStrings) {
            if ((0, common_1.dateFromString)(dateString, tz) < firstDate) {
                out.add(dateString);
            }
        }
    }
    return [...out];
}
